<template>
  <div class="container-fluid col-12 col-lg-10" id="container">

    <div class="cabecalho-projeto-meta">
      <nav class="breadcrumb-projeto" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/" class="text-decoration-none page-header-eyebrow">
            <b>Projetos</b>
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Projeto</li>
      </ol>
      </nav>

      <!-- BADGES (Creation Date / Autor(a)(a)) -->
      <div class="projeto-badges">
        <span class="azul badge bg-primary mb-2 me-2 d-inline-block">
          <b>Data de Criação: {{ converterDataBrasil(projeto.dataCriacao) }}</b> 
        </span>

        <span v-if="usuarioLogado && projeto.emailAutor !== usuarioLogado.email" class="azul badge bg-primary mb-2 me-2 d-inline-block">
          <b>Compartilhado por: {{ abreviarNome(projeto.autor) }}</b> 
        </span>

        <span v-else class="azul badge bg-primary mb-2 me-2 d-inline-block">
          <b>Autor(a): {{ abreviarNome(projeto.autor) }}</b>
        </span>
        
      </div>
    </div>

    <section class="page-header tour-projeto-cabecalho">
      <!-- PROJECT NAME -->
      <div>
        <h1 class="nome-projeto-titulo">
          {{ projeto.nome }}
        </h1>
      </div>
    </section>

    <!-- BOTÕES DE AÇÃO -->
    <section class="projeto-acao tour-imprimir-projeto">

      <div>
        <h2 class="titulo-secao-projeto">Imprimir projeto</h2>
        <p class="descricao-secao-projeto">
          Imprime um PDF com todos os componentes do projeto.
        </p>
      </div>

      <!-- IMPRIMIR -->
      <div>
        <button
          type="button"
          class="btn btn-secundario w-100"
          @click="carregarDadosComponentesProjetoImprimir()"
        >
          Imprimir
        </button>
      </div>

    </section>

    <!-- Título da seção -->
    <section class="projeto-secao mt-5">
      <h2 class="titulo-secao-projeto">1. Design Data</h2>
      <p class="descricao-secao-projeto">
        Parâmetros gerais utilizados por todos os componentes.
      </p>
    </section>

    <!-- Botão Design Data -->
    <div v-if="projeto.designData?.cod" class="projeto-design-data-acao">
      <router-link
        :to="`/app/calculator-design-data/${projeto.designData.cod}`"
        class="botao-azul botao btn btn-primary d-inline-flex align-items-center gap-2 text-decoration-none tour-design-data"
        target="_blank"
      >
        <!-- <i class="bi bi-sliders"></i> -->
        <b>DESIGN DATA</b>
      </router-link>
    </div>

    <!-- Seção de blocos e componentes -->
    <div class="m-1 mt-5">

      <div class="mb-2">
        <h2 class="titulo-secao-projeto">2. Componentes</h2>
        <p class="descricao-secao-projeto">
          Crie um novo bloco e adicione um novo componente ao projeto.
        </p>
      </div>

      <!-- Botões New Component e New Block -->
      <div class="col d-flex justify-content-start gap-2 mb-3">
        <button
          class="botao-azul btn btn-primary d-flex align-items-center gap-2 tour-adicionar-bloco"
          @click="adicionarBloco"
        >
          <span class="material-symbols-outlined">
            exposure_plus_1
          </span>
        </button>
      </div>

      <!-- Grid de Blocos -->
      <div class="blocos-grid row g-3 mb-3 tour-blocos-componentes">
        <div 
          v-for="bloco in blocos" 
          :key="bloco.id"
          :data-bloco-id="bloco.id"
          :class="[
            'col-12',
            'col-md-4',
            { 'bloco-arrastando': bloco.id === blocoArrastandoId }
          ]"
        >

          <div 
            class="bloco bloco-card p-3 text-center position-relative"
            :style="bloco.componente ? { backgroundColor: '#EDF7FF' } : {}"
            :draggable="bloco.componente ? true : false"
            @dragstart="iniciarArrastar(bloco.id, $event)"
            @dragover.prevent="sobreElemento($event)"
            @dragenter.prevent="sobreElemento($event)"
            @drop="soltarElemento(bloco.id)"
            @dragend="finalizarArrastar"
            @click="!bloco.componente ? abrirModalAdicionarComponente(bloco.id) : null"
          >
          
            <!-- Drag Handle (ícone) apenas em desktop -->
            <div
              v-if="bloco.componente"
              class="drag-icon icones-bloco drag-handle position-absolute top-0 start-0 p-1 text-secondary"
              title="Drag to reorder"
            >
              <i class="bi bi-grip-vertical"></i>
            </div>

            <!-- 3 pontinhos - Menu de opções -->
            <div v-if="bloco.componente" class="position-absolute top-0 end-0 p-1">
              <div class="btn-group">
                <button 
                  type="button" 
                  class="btn btn-sm btn-light" id="tres-pontinhos-componentes"
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                  @click.stop
                >
                  <i class="bi bi-three-dots-vertical"></i>
                </button>

                <div class="dropdown">
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <router-link
                        :to="`/app/${calculatorURL[bloco.componente.tipo]}${bloco.componente.cod}`"
                        class="dropdown-item"
                        target="_blank"
                        @click.stop
                      >
                        <i class="bi bi-box-arrow-up-right me-1"></i> Abrir
                      </router-link>
                    </li>
                    <li>
                      <button 
                        class="dropdown-item" 
                        @click="duplicarComponente(bloco.componente)"
                      >
                        <i class="bi bi-files me-1"></i> Duplicar
                      </button>
                    </li>
                    <li v-if="calculadorasComPosicao.includes(bloco.componente.tipo)">
                      <button
                        class="dropdown-item"
                        @click="abrirModalAlterarPosicao(bloco.componente)"
                      >
                        <i class="bi bi-arrows-expand me-1"></i>
                        Alterar posição
                      </button>
                    </li>
                    <li>
                      <button 
                        class="dropdown-item" 
                        @click="abrirModalRename(bloco.componente)" 
                        data-bs-toggle="modal" 
                        data-bs-target="#renomearComponenteModal"
                      >
                        <i class="bi bi-pencil me-1"></i> Renomear
                      </button>
                    </li>
                    <li>
                      <button 
                        class="dropdown-item" 
                        @click="abrirModalDelete(bloco.componente)" 
                        data-bs-toggle="modal" 
                        data-bs-target="#deletarComponenteModal"
                      >
                        <i class="bi bi-trash me-1"></i> Excluir
                      </button>
                    </li>
                    <!-- <li>
                      <button 
                        class="dropdown-item" 
                        @click="confirmarPrint(bloco.componente)"
                      >
                        <i class="bi bi-printer me-1"></i> Imprimir
                      </button>
                    </li> -->
                  </ul>
                </div>

              </div>
            </div>

            <!-- Lixeira para blocos vazios -->
            <div v-else class="position-absolute top-0 end-0 p-1">
              <button 
                type="button" 
                class="btn btn-sm btn-outline-danger border-0"
                @click.stop="deletarBlocoVazio(bloco.id)"
              >
                <i class="bi bi-trash"></i>
              </button>
            </div>

            <!-- Conteúdo do bloco -->
            <div class="d-flex flex-column align-items-center">
              <template v-if="bloco.componente">

                <!-- QUANDO DESIGN DATA ESTÁ OK -->
                <router-link
                  v-if="designDataValido"
                  :to="`/app/${calculatorURL[bloco.componente.tipo]}${bloco.componente.cod}`"
                  class="text-decoration-none titulo-componente"
                  target="_blank"
                  @click.stop
                >
                  <img
                    :src="calculadoraImagem[bloco.componente.tipo]"
                    alt="Imagem do componente"
                    class="img-componente mb-1"
                    :style="estiloImagemComponente(bloco.componente)"
                  />
                  <br>

                  <b>{{ bloco.componente.nomeComponente }}</b>

                  <div v-if="bloco.componente.elementoPaiCod">
                    Conectado a:
                    {{ nomeElementoPai(bloco.componente.elementoPaiCod) }}
                  </div>

                  <div v-if="bloco.componente.posicao">
                    Posição: {{ bloco.componente.posicao }}
                    <br>
                    <b>Bloco #{{ bloco.id }}</b>
                  </div>

                  <div v-else>
                    <b>Bloco #{{ bloco.id }}</b>
                  </div>
                </router-link>

              </template>

              <template v-else>
                <button
                  type="button"
                  class="btn btn-light d-flex align-items-center justify-content-center mb-1"
                  @click="clicarAdicionarComponente(bloco.id)"
                >
                  <span class="material-symbols-outlined">add</span>
                </button>

                <b>Bloco #{{ bloco.id }}</b>

              </template>

              <!-- Botões de mover apenas em blocos com componente -->
              <div
                v-if="bloco.componente"
                class="d-flex justify-content-center flex-wrap gap-1 mt-2"
              >
                <button
                  v-if="podeMoverParaEsquerda(bloco.id)"
                  class="botao-mover-bloco-azul btn btn-sm btn-primary"
                  @click="moverBlocoEsquerda(bloco.id)"
                  title="Mover para esquerda"
                >
                  ←
                </button>

                <button
                  v-if="podeMoverParaCima(bloco.id)"
                  class="botao-mover-bloco-azul btn btn-sm btn-primary"
                  @click="moverBlocoCima(bloco.id)"
                  title="Mover para cima"
                >
                  ↑
                </button>

                <button
                  v-if="podeMoverParaBaixo(bloco.id)"
                  class="botao-mover-bloco-azul btn btn-sm btn-primary"
                  @click="moverBlocoBaixo(bloco.id)"
                  title="Mover para baixo"
                >
                  ↓
                </button>

                <button
                  v-if="podeMoverParaDireita(bloco.id)"
                  class="botao-mover-bloco-azul btn btn-sm btn-primary"
                  @click="moverBlocoDireita(bloco.id)"
                  title="Mover para direita"
                >
                  →
                </button>
              </div>

            </div>

          </div>

        </div>
      </div>

      <!-- Tabela de componentes -->
      <div class="table-responsive tabela-componentes-container tour-componentes-lista">
        <table class="table tabela-componentes">
          <thead v-if="projeto.componentes && projeto.componentes.length">
            <tr>
              <th>Bloco ID</th>
              <th>Nome do Componente</th>
              <th>Nome da Calculadora</th>
              <th>Criado Por</th>
              <th>Data de Criação</th>
              <th class="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="componente in sortedComponentes" :key="componente.cod">
              <td>
                <router-link
                  :to="`/app/${calculatorURL[componente.tipo]}${componente.cod}`"
                  class="text-decoration-none titulo-componente"
                  target="_blank"
                >
                  <b>#{{ componente.blocoId }}</b>
                </router-link>
              </td>
              <td>
                <router-link
                  :to="`/app/${calculatorURL[componente.tipo]}${componente.cod}`"
                  class="text-decoration-none titulo-componente"
                  target="_blank"
                >
                  <b>{{ componente.nomeComponente }}</b>
                </router-link>

              </td>
              <td>{{ componente.nomeCalculadora }}</td>
              <td>{{ abreviarNome(componente.autor) }}</td>
              <td>{{ converterDataBrasil(componente.dataCriacao) }}</td>

              <td class="text-center">

                <!-- Botões de ações -->
                <div class="btn-group" role="group" aria-label="Button group with nested dropdown">

                  <router-link class="button btn btn-sm btn-info btn-secundario text-decoration-none"
                    :to="`/app/${calculatorURL[componente.tipo]}${componente.cod}`"
                    target="_blank"
                  >
                    
                    <b>Abrir</b>
                  </router-link>

                  <div class="btn-group">
                    <button 
                      type="button" 
                      class="btn btn-sm btn-secundario dropdown-toggle" 
                      data-bs-toggle="dropdown" 
                      data-bs-display="static"
                      aria-expanded="false"
                    >
                      <b>Opções</b>
                    </button>

                    

                      <ul class="dropdown-menu dropdown-menu-end">

                        <li>
                          <button 
                            class="dropdown-item" 
                            @click="duplicarComponente(componente)"
                          >
                            <i class="bi bi-files me-1"></i> Duplicar
                          </button>
                        </li>
                        <li v-if="calculadorasComPosicao.includes(componente.tipo)">
                          <button
                            class="dropdown-item"
                            @click="abrirModalAlterarPosicao(componente)"
                          >
                            <i class="bi bi-arrows-expand me-1"></i>
                            Alterar posição
                          </button>
                        </li>
                        <li>
                          <button 
                            class="dropdown-item" 
                            @click="abrirModalRename(componente)" 
                            data-bs-toggle="modal" 
                            data-bs-target="#renomearComponenteModal"
                          >
                            <i class="bi bi-pencil me-1"></i> Renomear
                          </button>
                        </li>
                        <li>
                          <button 
                            class="dropdown-item" 
                            @click="abrirModalDelete(componente)" 
                            data-bs-toggle="modal" 
                            data-bs-target="#deletarComponenteModal"
                          >
                            <i class="bi bi-trash me-1"></i> Excluir
                          </button>
                        </li>
                        <!-- <li>
                          <button 
                            class="dropdown-item" 
                            @click="confirmarPrint(componente)"
                          >
                            <i class="bi bi-printer me-1"></i> Imprimir
                          </button>
                        </li> -->

                      </ul>
                  </div>
                </div>
                
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <LoadingModal
      :visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />

    <!-- MODAL: ADD COMPONENT -->
    <div
      class="modal fade"
      id="adicionarComponenteModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-novo-projeto">

          <!-- FORM -->
          <form @submit.prevent="adicionarComponente" ref="formAdicionar">

            <!-- HEADER -->
            <div class="modal-header border-0 pb-2">
              <div class="d-flex align-items-center gap-2">
                <!-- <img src="../img/add-icon.svg" alt="Add" width="20" height="20"> -->
                <h5 class="modal-title mb-0">Novo componente</h5>
              </div>

              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <!-- BODY -->
            <div class="modal-body pt-0">

              <p class="text-muted mb-3">
                Defina o nome e selecione o tipo de calculadora.
              </p>

              <!-- Nome -->
              <div class="mb-3">
                <label class="form-label">Nome *</label>
                <input
                  type="text"
                  class="form-control input-projeto"
                  v-model="nomeCalculo"
                  placeholder="Nome do novo componente"
                  required
                />
              </div>

              <!-- Tipo de Calculadora -->
              <div class="mb-2">
                <label class="form-label">Tipo de calculadora *</label>

                <div class="calculator-grid mt-2">
                  <div
                    v-for="calc in calculadoras"
                    :key="calc.tipo"
                    class="calculator-card"
                    :class="{ selected: calculadoraSelecionada?.tipo === calc.tipo }"
                    @click="selecionarCalculadora(calc)"
                  >
                    <img :src="calc.imagem" class="calculator-img" />
                    <div class="calculator-name">
                      {{ calc.nome }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Posição (condicional) -->
              <div v-if="exigirPosicao" class="mb-3 mt-3">
                <label class="form-label">Posição do componente *</label>

                <select
                  class="form-select w-50"
                  v-model="posicaoSelecionada"
                  required
                >
                  <option
                    v-for="posicao in opcoesPosicao(calculadoraSelecionada?.tipo)"
                    :key="posicao"
                    :value="posicao"
                  >
                    {{ posicao }}
                  </option>
                </select>
              </div>
              
              <!-- Bocal conectado ao elemento pai -->
              <div v-if="isBocalOrFlange" class="mb-3 mt-3">
                <label class="form-label">Conectado a qual componente? *</label>

                <select
                  class="form-select w-50"
                  v-model="elementoPaiSelecionado"
                  required
                >
                  <option
                    v-for="componente in componentesPaisPermitidos"
                    :key="componente.cod"
                    :value="componente.cod"
                  >
                    {{ componente.nomeComponente }} - Bloco #{{ componente.blocoId }}
                  </option>
                </select>
              </div>

            </div>

            <!-- FOOTER -->
            <div class="modal-footer border-0 pt-0">
              <button
                type="button"
                class="btn btn-secundario"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>

              <button
                type="submit"
                class="btn btn-primary botao-azul"
              >
                Criar componente
              </button>
            </div>

          </form>

        </div>
      </div>
    </div>

    <!-- MODAL: RENAME COMPONENT -->
    <div class="modal fade" id="renomearComponenteModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-novo-projeto">

          <!-- HEADER -->
          <div class="modal-header border-0 pb-2">
            <div class="d-flex align-items-center gap-2">
              <h5 class="modal-title mb-0">Renomear componente</h5>
            </div>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <!-- BODY -->
          <div class="modal-body pt-0">
            <p class="text-muted mb-3">
              Escolha um novo nome para o seu componente.
            </p>

            <input
              type="text"
              class="form-control input-projeto" id="renomearComponente"
              placeholder="New component name"
              v-model="novoNomeComponente"
            >
          </div>

          <!-- FOOTER -->
          <div class="modal-footer border-0 pt-0">

            <button
              type="button"
              class="btn btn-secundario"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-primary botao-azul"
              data-bs-dismiss="modal"
              @click="confirmarRename"
            >
              Salvar alterações
            </button>

          </div>

        </div>
      </div>
    </div>

    <!-- MODAL: ALTERAR POSIÇÃO DO COMPONENTE -->
    <div class="modal fade" id="alterarPosicaoComponenteModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-novo-projeto">

          <div class="modal-header border-0 pb-2">
            <div class="d-flex align-items-center gap-2">
              <h5 class="modal-title mb-0">Alterar posição</h5>
            </div>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <div class="modal-body pt-0">
            <p class="text-muted mb-3">
              Selecione a nova posição para o componente <strong>{{ componenteParaAlterarPosicao?.nomeComponente }}</strong>.
            </p>

            <select
              v-model="posicaoTemporaria"
              class="form-select w-100"
            >
              <option
                v-for="posicao in opcoesPosicao(componenteParaAlterarPosicao?.tipo)"
                :key="posicao"
                :value="posicao"
              >
                {{ posicao }}
              </option>
            </select>
          </div>

          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-secundario" data-bs-dismiss="modal">
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-primary botao-azul"
              data-bs-dismiss="modal"
              @click="confirmarAlterarPosicaoComponente"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL: DELETE COMPONENT -->
    <div class="modal fade" id="deletarComponenteModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-novo-projeto">

          <!-- HEADER -->
          <div class="modal-header border-0 pb-2">
            <div class="d-flex align-items-center gap-2">
              <h5 class="modal-title mb-0">Excluir componente</h5>
            </div>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <!-- BODY -->
          <div class="modal-body pt-0">
            <p class="text-muted mb-2">
              Tem certeza de que deseja excluir o componente <strong>{{ componenteSelecionadoParaDeletar?.nomeComponente }}</strong>?
            </p>
          </div>

          <!-- FOOTER -->
          <div class="modal-footer border-0 pt-0">

            <button
              type="button"
              class="btn btn-secundario"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-primary botao-azul"
              data-bs-dismiss="modal"
              @click="confirmarDelete"
            >
              Excluir projeto
            </button>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getUsuario } from '@/utils/authStorage';
import { useRoute } from "vue-router";
import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { Modal } from "bootstrap";
// IMPRIMIR
import { jsPDF } from "jspdf";
import { logoBase64 } from '../calculadoras/imgBase64/logoBase64.js';
import { drawingShellCilindInternalPressBase64 } from '../calculadoras/imgBase64/drawingShellCilindInternalPressBase64.js';
import { drawingSphericalShellsPressConcaveBase64 } from '../calculadoras/imgBase64/drawingSphericalShellsPressConcaveBase64.js';
import { drawingShellConicalInternalPressBase64 } from '../calculadoras/imgBase64/drawingShellConicalInternalPressBase64.js';
import { drawingEllipsoidalHeadPressConcaveBase64 } from '../calculadoras/imgBase64/drawingEllipsoidalHeadPressConcaveBase64.js';
import { drawingTorispleHeadPressConcaveBase64 } from '../calculadoras/imgBase64/drawingTorispleHeadPressConcaveBase64.js';
import { drawingFlangeIntegralBase64 } from '../calculadoras/imgBase64/drawingFlangeIntegralBase64.js';
import { drawingBocalBase64 } from '../calculadoras/imgBase64/drawingBocalBase64.js';


export default {
  name: "Calculo",
  data() {
    return {
      calculatorURL: {
        0: `calculator-design-data/`,
        1: `calculator-shell-cilind-internal-press/`,
        2: `calculator-spherical-shells-press-concave/`,
        3: `calculator-shell-conical-internal-press/`,
        4: `calculator-ellipsoidal-head-press-concave/`,
        5: `calculator-torisple-head-press-concave/`,
        6: `calculator-flange-integral/`,
        7: `calculator-bocal/`
      },
      calculadoraImagem: {
        1: require('./img/1.png'),
        2: require('./img/2.png'),
        3: require('./img/3.png'),
        4: require('./img/4.png'),
        5: require('./img/5.png'),
        6: require('./img/6.png'),
        7: require('./img/7.png')
      },
      calculadoras: [
        { tipo: 1, nome: "Shell Cilind Internal Press", imagem: require("./img/1.png") },
        { tipo: 2, nome: "Spherical Shells Press Concave", imagem: require("./img/2.png") },
        { tipo: 3, nome: "Shell Conical Internal Press", imagem: require("./img/3.png") },
        { tipo: 4, nome: "Ellipsoidal Head Press Concave", imagem: require("./img/4.png") },
        { tipo: 5, nome: "Torispherical Head Press Concave", imagem: require("./img/5.png") },
        { tipo: 6, nome: "Flange Integral", imagem: require("./img/6.png") },
        { tipo: 7, nome: "Bocal", imagem: require("./img/7.png") }
      ],

      calculadoraSelecionada: null,

      usuario: null,
      usuarioLogado: null,
      usuarioSemPermissao: false,
      projeto: { cod: 0, tipo: 0, nomeProjeto: "", nomeCalculadora: "Shell Cilind Internal Press", componentes: [], designData: null },
      blocos: [],
      contadorBlocos: 1,
      blocoSelecionadoId: null,
      componenteSelecionadoParaRenomear: null,
      componenteSelecionadoParaDeletar: null,
      novoNomeComponente: '',
      nomeCalculo: "",
      nomeCalculadora: "Shell Cilind Internal Press",

      // Verifica se o design data foi preenchido
      designDataValido: false,
      verificandoDesignData: true,

      // Variáveis para drag and drop
      blocoArrastandoId: null,
      blocoSendoSobrepostoId: null,

      // Tampas
      designDataPosition: null,

      exigirPosicao: false,
      posicaoSelecionada: "Cima",
      posicaoTemporaria: "Cima",
      componenteParaAlterarPosicao: null,

      calculadorasComPosicao: [2, 3, 4, 5, 6, 7],

      // Bocais
      elementoPaiSelecionado: null,

      // Modal loading
      loadingModal: null,
      loadingModalAberto: false,

      // Modal de loading
      loading: {
        visible: false,
      },

      // Modal de mensagens genéricas
      alertModal: {
        visivel: false,
        titulo: '',
        mensagem: '',
        tipo: 'info' // success | danger | warning | info
      },
    }
  },
  components: {
    AlertModal,
    LoadingModal
  },
  computed: {
    sortedComponentes() {
      if (!this.projeto.componentes) return [];

      return [...this.projeto.componentes].sort((a, b) => {
        // Garantir que blocos sem blocoId vão para o final
        if (a.blocoId == null) return 1;
        if (b.blocoId == null) return -1;

        return a.blocoId - b.blocoId;
      });
    },

    isBocalOrFlange() {
      if (this.calculadoraSelecionada?.tipo === 7 || this.calculadoraSelecionada?.tipo === 6) {
        return true;
      }
      return false;
    },

    componentesPaisPermitidos() {
      if (!this.projeto?.componentes) return [];

      return this.projeto.componentes.filter(c =>
        c.tipo >= 1 && c.tipo <= 5
      );
    }
  },
  mounted() {

    document.addEventListener('click', this.fecharOutrosDropdowns, true);

    const route = useRoute();
    this.projeto.cod = route.params.cod;
    const usuarioSalvo = getUsuario();
    this.usuarioLogado = usuarioSalvo ? {
      ...usuarioSalvo,
      nome: usuarioSalvo.nome
    } : null;
    this.abrirLoading();
    this.verificarDesignData(this.projeto.cod);
    this.carregarComponentesProjeto(this.projeto.cod);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.fecharOutrosDropdowns, true);
  },
  methods: {

    fecharOutrosDropdowns(event) {
      const toggle = event.target.closest('[data-bs-toggle="dropdown"]');
      if (!toggle) return;

      const dropdownAtual = toggle.closest('.btn-group, .dropdown, .bloco')
        ?.querySelector('.dropdown-menu');

      document.querySelectorAll('.dropdown-menu.show').forEach((menu) => {
        if (menu !== dropdownAtual) {
          menu.classList.remove('show');
          menu.closest('.dropdown, .btn-group')
            ?.querySelector('[data-bs-toggle="dropdown"]')
            ?.setAttribute('aria-expanded', 'false');
        }
      });
    },

    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    fecharAlert() {
      this.alertModal.visible = false;
      localStorage.setItem('ocultarAjudaArrastarBlocos', 'true');
    },

    abrirLoading() {
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    abreviarNome(nome) {
      if (!nome) return '';

      const partes = nome
        .trim()
        .split(' ')
        .filter(Boolean);

      if (partes.length === 1) return partes[0];

      return `${partes[0]} ${partes[partes.length - 1]}`;
    },

    opcoesPosicao(tipoComponente) {
      const eTampa = tipoComponente >= 2 && tipoComponente <= 5;

      if (eTampa && this.designDataPosition === 'Horizontal') {
        return ['Esquerda', 'Direita'];
      }

      if (tipoComponente === 6 || tipoComponente === 7) {
        return ['Cima', 'Baixo', 'Esquerda', 'Direita'];
      }

      return ['Cima', 'Baixo'];
    },

    posicaoPadrao(tipoComponente) {
      const opcoes = this.opcoesPosicao(tipoComponente);
      return opcoes.includes('Direita') ? 'Direita' : opcoes[0] || 'Cima';
    },

    estiloImagemComponente(componente) {
      if (!componente) {
        return {};
      }

      const vasoEmVertical = this.designDataPosition === 'Vertical';
      const eComponenteComPosicao = this.calculadorasComPosicao.includes(componente.tipo);

      const mapaRotacaoPadrao = {
        Cima: 270,
        Baixo: 90,
        Esquerda: 180,
        Direita: 0,
      };
      const eTampa = componente.tipo >= 2 && componente.tipo <= 5;
      const eFlangeOuBocal = componente.tipo === 6 || componente.tipo === 7;
      const mapaRotacaoTampa = {
        Cima: 90,
        Baixo: 270,
        Esquerda: 0,
        Direita: 180,
      };
      const mapaRotacaoFlangeOuBocal = {
        Cima: 0,
        Baixo: 180,
        Esquerda: 270,
        Direita: 90,
      };

      let rotacao = (eFlangeOuBocal
        ? mapaRotacaoFlangeOuBocal
        : eTampa ? mapaRotacaoTampa : mapaRotacaoPadrao)[componente.posicao] ?? 0;

      if (vasoEmVertical && componente.tipo === 1) {
        rotacao = (rotacao + 90) % 360;
      } else if (eComponenteComPosicao && !eTampa && !eFlangeOuBocal) {
        if (vasoEmVertical) {
          rotacao = (rotacao + 90) % 360;
        }
      }

      return {
        transform: `rotate(${rotacao}deg)`,
        transition: 'transform 0.2s ease',
        transformOrigin: 'center center'
      };
    },

    converterDataBrasil(data) {
      if (!data) return '';

      const partes = data.split('-');
      if (partes.length !== 3) return data;

      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },

    clicarAdicionarComponente(blocoId) {

      if (!this.designDataValido) {
        this.alertarDesignData();
        return;
      }

      this.abrirModalAdicionarComponente(blocoId);

      const el = document.getElementById("adicionarComponenteModal");
      const modal = Modal.getOrCreateInstance(el);
      modal.show();
    },

    alertarDesignData() {
      this.abrirAlert(
        "Design Data obrigatório",
        "Antes de adicionar um componente, preencha corretamente o DESIGN DATA do projeto.",
        "warning"
      );
    },

    verificarDesignData(codProjeto) {
      fetch(`${process.env.VUE_APP_BACKEND_URL}/verificar-design-data/${codProjeto}`)
        .then(res => res.json())
        .then(data => {
          this.designDataValido = data.preenchido;
        })
        .catch(() => {
          this.designDataValido = false;
        })
        .finally(() => {
          this.verificandoDesignData = false;
        });
    },

    // Bocal
    nomeElementoPai(codPai) {
      if (!codPai || !this.projeto?.componentes) return '';

      const pai = this.projeto.componentes.find(
        c => c.cod === codPai
      );

      return pai
        ? `${pai.nomeComponente}`
        : 'Não encontrado';
    },

    selecionarCalculadora(calc) {
      this.calculadoraSelecionada = calc;
      this.posicaoSelecionada = this.posicaoPadrao(calc.tipo);
      this.exigirPosicao = this.calculadorasComPosicao.includes(calc.tipo);
    },

    carregarDesignDataPorCod() {
      if (!this.projeto?.cod) return;

      fetch(`${process.env.VUE_APP_BACKEND_URL}/buscar-design-data/${this.projeto.cod}`)
        .then(res => res.json())
        .then(data => {
          const designData = data?.designData || {};
          const position = designData.designData?.position ?? designData.position ?? null;
          this.designDataPosition = position;
        })
        .catch(err => {
          console.error('Erro ao buscar design data:', err);
          this.designDataPosition = null;
        });
    },

    // Atualize o método carregarComponentesProjeto:
    carregarComponentesProjeto(codProjeto) {
      
      fetch(`${process.env.VUE_APP_BACKEND_URL}/carregar-componentes-projeto/${codProjeto}?email=${this.usuarioLogado.email}`)
        .then(res => {
          
          // BACKEND decide o acesso
          if (res.status === 401 || res.status === 403) {
            this.fecharLoading();

            window.location.href = '/';

            throw new Error('Acesso negado');
          }

          if (!res.ok) {
            throw new Error('Erro ao carregar projeto');
          }

          return res.json();
        })
        .then(data => {

          // 1 - CARREGA PROJETO
          this.projeto = {
            ...data.projeto,
            componentes: data.projeto?.componentes || []
          };

          // 2 - DESCOBRE O MAIOR BLOCO ID
          let maxBlocoId = 0;

          this.projeto.componentes.forEach(c => {
            if (typeof c.blocoId === 'number' && c.blocoId > maxBlocoId) {
              maxBlocoId = c.blocoId;
            }
          });

          // 3 - CRIA BLOCOS BASE (mínimo de 9)
          this.blocos = [];

          const quantidadeInicial = Math.max(9, maxBlocoId > 0 ? maxBlocoId : 1);

          for (let i = 1; i <= quantidadeInicial; i++) {
            this.blocos.push({
              id: i,
              componente: null
            });
          }

          // 4 - DISTRIBUI COMPONENTES
          this.projeto.componentes.forEach(componente => {
            if (!componente || typeof componente.blocoId !== 'number') {
              return;
            }

            // tenta usar o bloco original
            let bloco = this.blocos.find(b => b.id === componente.blocoId);

            if (bloco && !bloco.componente) {
              // bloco livre → ok
              bloco.componente = componente;
            } else {
              // bloco ocupado ou inexistente
              // cria novo bloco automaticamente
              const novoId = Math.max(...this.blocos.map(b => b.id)) + 1;

              componente.blocoId = novoId;

              this.blocos.push({
                id: novoId,
                componente
              });
            }
          });

          // 5 - ORDENA E AJUSTA CONTADOR
          this.blocos.sort((a, b) => a.id - b.id);

          this.contadorBlocos =
            this.blocos.length > 0
              ? Math.max(...this.blocos.map(b => b.id)) + 1
              : 1;

          // 6 - POPUP DE AJUDA (se aplicável)
          // this.abrirPopupSeProjetoNovo();

          // 7- BUSCAR DESIGN DATA
          this.carregarDesignDataPorCod();

        })
        .catch(err => {
          console.error("Erro ao carregar componentes:", err);
          this.projeto = { 
            cod: this.projeto.cod, 
            tipo: 0, 
            nomeProjeto: "", 
            nomeCalculadora: "Shell Cilind Internal Press", 
            componentes: [], 
            designData: null 
          };
          this.blocos = [];
        })
        .finally(() => {
          this.fecharLoading();
        });
    },

    adicionarBloco() {
      this.blocos.push({ id: this.contadorBlocos, componente: null });
      this.contadorBlocos++;
    },

    // Métodos de Drag and Drop
    iniciarArrastar(blocoId, event) {
      const bloco = this.blocos.find(b => b.id === blocoId);
      if (bloco && bloco.componente) {
        this.blocoArrastandoId = blocoId;
        event.dataTransfer.setData('text/plain', blocoId.toString());
        event.dataTransfer.effectAllowed = 'move';
        
        // Adiciona estilo visual durante o arrasto
        event.currentTarget.classList.add('arrastando');
      }
    },

    sobreElemento(event) {
      event.preventDefault();
      
      // Encontra o elemento pai com o data-bloco-id
      let elemento = event.target;
      while (elemento && !elemento.hasAttribute('data-bloco-id')) {
        elemento = elemento.parentElement;
      }
      
      if (elemento && elemento.hasAttribute('data-bloco-id')) {
        const blocoId = parseInt(elemento.getAttribute('data-bloco-id'));
        if (blocoId !== this.blocoSendoSobrepostoId) {
          // Remove classe do bloco anterior
          if (this.blocoSendoSobrepostoId) {
            const elementoAnterior = document.querySelector(`[data-bloco-id="${this.blocoSendoSobrepostoId}"]`);
            if (elementoAnterior) {
              elementoAnterior.classList.remove('sobreposto');
            }
          }
          
          this.blocoSendoSobrepostoId = blocoId;
          
          // Adiciona feedback visual
          elemento.classList.add('sobreposto');
        }
      }
    },

    soltarElemento(blocoAlvoId) {
      if (!this.blocoArrastandoId || this.blocoArrastandoId === blocoAlvoId) {
        this.limparEstilosArrasto();
        return;
      }

      const blocoOrigemIndex = this.blocos.findIndex(b => b.id === this.blocoArrastandoId);
      const blocoAlvoIndex = this.blocos.findIndex(b => b.id === blocoAlvoId);

      if (blocoOrigemIndex !== -1 && blocoAlvoIndex !== -1) {
        // Troca os componentes entre os blocos
        const componenteOrigem = this.blocos[blocoOrigemIndex].componente;
        const componenteAlvo = this.blocos[blocoAlvoIndex].componente;

        // Atualiza blocoId nos componentes se existirem
        if (componenteOrigem) {
          componenteOrigem.blocoId = blocoAlvoId;
        }
        if (componenteAlvo) {
          componenteAlvo.blocoId = this.blocoArrastandoId;
        }

        // Troca os componentes
        this.blocos[blocoOrigemIndex].componente = componenteAlvo;
        this.blocos[blocoAlvoIndex].componente = componenteOrigem;

        // Atualiza no backend
        this.atualizarOrdemBlocosNoBackend();
      }

      this.limparEstilosArrasto();
    },

    finalizarArrastar() {
      this.blocoArrastandoId = null;
      this.blocoSendoSobrepostoId = null;
      this.limparEstilosArrasto();
    },

    limparEstilosArrasto() {
      // Remove todas as classes de estilo do drag and drop
      document.querySelectorAll('.arrastando, .sobreposto').forEach(el => {
        el.classList.remove('arrastando', 'sobreposto');
      });
    },

    atualizarOrdemBlocosNoBackend() {
      // Encontra os blocos envolvidos na troca
      const blocoOrigem = this.blocos.find(b => b.id === this.blocoArrastandoId);
      const blocoAlvo = this.blocos.find(b => b.id === this.blocoSendoSobrepostoId);

      if (!blocoOrigem || !blocoAlvo) {
        console.log('Blocos não encontrados');
        return;
      }

      // Prepara os dados no formato que o backend espera
      const dadosParaEnviar = {
        codProjeto: this.projeto.cod,
        componente1: {
          codComponente: blocoOrigem?.componente?.cod || null,
          blocoId: blocoAlvo.id
        },
        componente2: {
          codComponente: blocoAlvo?.componente?.cod || null,
          blocoId: blocoOrigem.id
        }
      };

      // Se não há nenhum componente para atualizar (ambos são null), não chama o backend
      if (!dadosParaEnviar.componente1.codComponente && !dadosParaEnviar.componente2.codComponente) {
        console.log('Nenhum componente para atualizar - ambos blocos vazios');
        return;
      }

      // Envia para o backend
      fetch(`${process.env.VUE_APP_BACKEND_URL}/atualizar-blocos-componentes-arrastar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dadosParaEnviar),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao atualizar blocos');
        }
        return response.json();
      })
      .then(data => {
        console.log('Blocos atualizados com sucesso!', data);
      })
      .catch(err => {
        console.error("Erro ao atualizar blocos:", err);
        this.reverterTrocaLocal();
      });
    },

    reverterTrocaLocal() {
      const blocoOrigem = this.blocos.find(b => b.id === this.blocoArrastandoId);
      const blocoAlvo = this.blocos.find(b => b.id === this.blocoSendoSobrepostoId);
      
      if (blocoOrigem && blocoAlvo) {
        // Reverte a troca
        const temp = blocoOrigem.componente;
        blocoOrigem.componente = blocoAlvo.componente;
        blocoAlvo.componente = temp;
        
        // Reverte os blocoIds
        if (blocoOrigem.componente) blocoOrigem.componente.blocoId = blocoOrigem.id;
        if (blocoAlvo.componente) blocoAlvo.componente.blocoId = blocoAlvo.id;
        
        console.log('Troca revertida localmente devido a erro no backend');
      }
    },

    abrirModalAdicionarComponente(blocoId) {
      // Verifica se o Design Data foi preenchido
      if (!this.designDataValido) {
        this.abrirAlert(
          'Sistema',
          'Você precisa preencher o DESIGN DATA antes de criar componentes.',
          'warning'
        );
        return;
      }

      this.blocoSelecionadoId = blocoId;
      this.nomeCalculo = "";
      this.nomeCalculadora = "Shell Cilind Internal Press";
    },

    quantidadeColunasBlocos() {
      return window.innerWidth >= 768 ? 3 : 1;
    },

    podeMoverParaEsquerda(id) {
      const index = this.blocos.findIndex(b => b.id === id);
      if (index === -1) return false;
      return index % this.quantidadeColunasBlocos() !== 0;
    },

    podeMoverParaDireita(id) {
      const index = this.blocos.findIndex(b => b.id === id);
      if (index === -1) return false;
      const colunas = this.quantidadeColunasBlocos();
      return (index % colunas) !== colunas - 1 && index + 1 < this.blocos.length;
    },

    podeMoverParaCima(id) {
      const index = this.blocos.findIndex(b => b.id === id);
      if (index === -1) return false;
      return index >= this.quantidadeColunasBlocos();
    },

    podeMoverParaBaixo(id) {
      const index = this.blocos.findIndex(b => b.id === id);
      if (index === -1) return false;
      const colunas = this.quantidadeColunasBlocos();
      return index + colunas < this.blocos.length;
    },

    moverBlocoEsquerda(id) {
      this.moverBlocoNaDirecao(id, 'Esquerda');
    },

    moverBlocoDireita(id) {
      this.moverBlocoNaDirecao(id, 'Direita');
    },

    moverBlocoCima(id) {
      this.moverBlocoNaDirecao(id, 'Cima');
    },

    moverBlocoBaixo(id) {
      this.moverBlocoNaDirecao(id, 'Baixo');
    },

    moverBlocoNaDirecao(id, direcao) {
      const index = this.blocos.findIndex(b => b.id === id);
      if (index === -1) return;

      const colunas = this.quantidadeColunasBlocos();
      let novoIndex = index;

      switch (direcao) {
        case 'Esquerda':
          if (!this.podeMoverParaEsquerda(id)) return;
          novoIndex = index - 1;
          break;
        case 'Direita':
          if (!this.podeMoverParaDireita(id)) return;
          novoIndex = index + 1;
          break;
        case 'Cima':
          if (!this.podeMoverParaCima(id)) return;
          novoIndex = index - colunas;
          break;
        case 'Baixo':
          if (!this.podeMoverParaBaixo(id)) return;
          novoIndex = index + colunas;
          break;
        default:
          return;
      }

      const blocoOrigem = this.blocos[index];
      const blocoDestino = this.blocos[novoIndex];

      if (!blocoDestino) return;

      this.blocos.splice(index, 1, blocoDestino);
      this.blocos.splice(novoIndex, 1, blocoOrigem);

      this.atualizarOrdemBlocosNoBackendMobile(blocoOrigem.id, blocoDestino.id);
      this.recalcularBlocoIds();
      this.blocos = [...this.blocos];
    },

    recalcularBlocoIds() {
      this.blocos.forEach((bloco, idx) => {
        bloco.id = idx + 1;
        if (bloco.componente) {
          bloco.componente.blocoId = bloco.id;
        }
      });
    },

    atualizarOrdemBlocosNoBackendMobile(blocoIdOrigem, blocoIdDestino) {
      const bloco1 = this.blocos.find(b => b.id === blocoIdOrigem);
      const bloco2 = this.blocos.find(b => b.id === blocoIdDestino);

      if (!bloco1 || !bloco2) return;

      const dadosParaEnviar = {
        codProjeto: this.projeto.cod,
        componente1: {
          codComponente: bloco1?.componente?.cod || null,
          blocoId: bloco1.id
        },
        componente2: {
          codComponente: bloco2?.componente?.cod || null,
          blocoId: bloco2.id
        }
      };

      console.log('Enviando dados para backend:', dadosParaEnviar);

      fetch(`${process.env.VUE_APP_BACKEND_URL}/atualizar-blocos-componentes-arrastar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dadosParaEnviar),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao atualizar blocos');
        }
        return response.json();
      })
      .then(data => {
        console.log('Blocos atualizados com sucesso!', data);
      })
      .catch(err => {
        console.error("Erro ao atualizar blocos:", err);
        this.reverterTrocaMobile(blocoIdOrigem, blocoIdDestino);
      });
    },

    reverterTrocaMobile(blocoIdOrigem, blocoIdDestino) {
      const bloco1Index = this.blocos.findIndex(b => b.id === blocoIdOrigem);
      const bloco2Index = this.blocos.findIndex(b => b.id === blocoIdDestino);

      if (bloco1Index === -1 || bloco2Index === -1) return;

      [this.blocos[bloco2Index].componente, this.blocos[bloco1Index].componente] = 
      [this.blocos[bloco1Index].componente, this.blocos[bloco2Index].componente];

      if (this.blocos[bloco1Index].componente) this.blocos[bloco1Index].componente.blocoId = this.blocos[bloco1Index].id;
      if (this.blocos[bloco2Index].componente) this.blocos[bloco2Index].componente.blocoId = this.blocos[bloco2Index].id;

      console.log('Troca revertida localmente devido a erro no backend');
    },

    deletarBlocoVazio(blocoId) {
      const blocoIdParaDeletar = blocoId;
      
      // Guarda os componentes antes da deleção para possível rollback
      const blocosAntes = JSON.parse(JSON.stringify(this.blocos));
      
      try {
        // 1. Remove o bloco vazio do array de blocos
        this.blocos = this.blocos.filter(bloco => bloco.id !== blocoIdParaDeletar);
        
        // 2. Reduz -1 no ID de TODOS os blocos à direita
        this.blocos.forEach(bloco => {
          if (bloco.id > blocoIdParaDeletar) {
            const novoId = bloco.id - 1;
            
            if (bloco.componente) {
              bloco.componente.blocoId = novoId;
            }
            
            bloco.id = novoId;
          }
        });
        
        // 3. Reordena os blocos pelo ID
        this.blocos.sort((a, b) => a.id - b.id);
        
        // 4. Atualiza o contadorBlocos
        this.contadorBlocos = this.blocos.length > 0 
          ? Math.max(...this.blocos.map(b => b.id)) + 1 
          : 1;
        
        // 5. Envia para o backend
        this.atualizarIdsAposDelecaoNoBackend(blocoIdParaDeletar);
        
      } catch (error) {
        console.error('Erro ao deletar bloco vazio:', error);
        // Reverte as alterações locais
        this.blocos = blocosAntes;
      }
    },

    atualizarIdsAposDelecaoNoBackend(blocoIdDeletado) {
      // Prepara uma lista de todos os componentes que precisam ser atualizados
      const componentesParaAtualizar = this.blocos
        .filter(bloco => bloco.componente && bloco.id >= blocoIdDeletado)
        .map(bloco => ({
          codComponente: bloco.componente.cod,
          novoBlocoId: bloco.id
        }));

      console.log('Componentes para atualizar após deleção:', componentesParaAtualizar);

      // Se não há componentes para atualizar, não chama o backend
      if (componentesParaAtualizar.length === 0) {
        console.log('Nenhum componente para atualizar após deleção');
        return;
      }

      // Envia para o backend - NO FORMATO CORRETO
      fetch(`${process.env.VUE_APP_BACKEND_URL}/atualizar-blocos-apos-delecao-bloco-vazio`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          codProjeto: this.projeto.cod,
          componentes: componentesParaAtualizar
          // REMOVER blocoIdDeletado - o endpoint não espera isso
        }),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao atualizar blocos após deleção');
        }
        return response.json();
      })
      .then(data => {
        console.log('Blocos atualizados após deleção!', data);
      })
      .catch(err => {
        console.error("Erro ao atualizar blocos após deleção:", err);
        // Recarrega a página para sincronizar com o backend
        // window.location.reload();
      });
    },

    async adicionarComponente() {

      // Validação
      if (!this.calculadoraSelecionada) {
        this.abrirAlert("Sistema", "Selecione uma calculadora", "error");
        return;
      }

      if (this.calculadorasComPosicao.includes(this.calculadoraSelecionada?.tipo) && !this.posicaoSelecionada) {
        this.abrirAlert(
          'Sistema',
          'Selecione a posição do componente (cima ou baixo).',
          'warning'
        );
        return;
      }

      if (this.isBocalOrFlange && !this.elementoPaiSelecionado) {
        this.abrirAlert(
          'Sistema',
          'Selecione o elemento pai do bocal.',
          'warning'
        );
        return;
      }

      if (this.isBocalOrFlange) {
        const valido = this.componentesPaisPermitidos
          .some(c => c.cod === this.elementoPaiSelecionado);

        if (!valido) {
          this.abrirAlert(
            'Sistema',
            'Elemento pai inválido para o bocal.',
            'error'
          );
          return;
        }
      }

      const user = getUsuario() || {};
      const autor = user.nome || 'Unknown';
      const emailAutor = user.email || 'Unknown';

      // Todos os componentes
      const componente = {
        nomeComponente: this.nomeCalculo,
        nomeCalculadora: this.calculadoraSelecionada.nome,
        tipo: this.calculadoraSelecionada.tipo,
        autor,
        emailAutor,
        dataCriacao: new Date().toISOString().split('T')[0],
        cod: Date.now(),
        blocoId: this.blocoSelecionadoId
      };

      // Componentes com posição definida → posição
      if (this.calculadorasComPosicao.includes(this.calculadoraSelecionada.tipo)) {
        componente.posicao = this.posicaoSelecionada;
      }

      // Bocal → elemento pai
      if (this.calculadoraSelecionada.tipo === 7 || this.calculadoraSelecionada.tipo === 6) {
        componente.elementoPaiCod = this.elementoPaiSelecionado;
      }

      // Adiciona ao bloco selecionado
      if (this.blocoSelecionadoId) {
        const bloco = this.blocos.find(b => b.id === this.blocoSelecionadoId);
        if (bloco) bloco.componente = componente;
        this.blocoSelecionadoId = null;
      }

      // Adiciona à lista geral
      this.projeto.componentes.push(componente);

      // Limpa inputs
      this.nomeCalculo = "";
      this.calculadoraSelecionada = null;
      this.posicaoSelecionada = this.posicaoPadrao(2);
      this.elementoPaiSelecionado = null;

      try {
        const response = await fetch(`${process.env.VUE_APP_BACKEND_URL}/criar-novo-componente-no-projeto`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            codProjeto: this.projeto.cod,
            componente
          }),
        });

        if (!response.ok) {
          throw new Error('Erro ao criar componente');
        }

        // Recarrega a página somente após confirmação do backend
        window.location.reload();
      } catch (err) {
        this.projeto.componentes = this.projeto.componentes.filter(c => c.cod !== componente.cod);
        console.error('Erro ao criar componente:', err);
        this.abrirAlert(
          'Sistema',
          'Não foi possível criar o componente. Tente novamente.',
          'error'
        );
      }
    },

    abrirModalDelete(componente) {
      this.componenteSelecionadoParaDeletar = componente;
    },

    confirmarDelete() {
      if (!this.componenteSelecionadoParaDeletar) return;

      const cod = this.componenteSelecionadoParaDeletar.cod;

      fetch(`${process.env.VUE_APP_BACKEND_URL}/deletar-componente/${cod}`, {
        method: 'DELETE'
      })
        .then(res => {
          if (!res.ok) {
            throw new Error('Erro ao deletar componente');
          }
          return res.json();
        })
        .then(() => {

          // Remove da lista geral
          this.projeto.componentes = this.projeto.componentes.filter(
            c => c.cod !== cod
          );

          // Remove do bloco correspondente
          this.blocos.forEach(bloco => {
            if (bloco.componente?.cod === cod) {
              bloco.componente = null;
            }
          });

          this.componenteSelecionadoParaDeletar = null;

          window.location.reload();

        })
        .catch(err => {
          console.error('Erro ao deletar componente:', err);

          this.abrirAlert(
            'Erro',
            'Não foi possível excluir o componente. Tente novamente.',
            'danger'
          );
        });
    },

    duplicarComponente(componente) {

      this.abrirLoading();

      const novoBlocoId = this.blocos.length > 0 
        ? Math.max(...this.blocos.map(b => b.id)) + 1 
        : 1;

      fetch(`${process.env.VUE_APP_BACKEND_URL}/duplicar-componente`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          codProjeto: this.projeto.cod,
          codComponente: componente.cod,
          novoBlocoId: novoBlocoId, // Envia o novo blocoId para o backend
        }),
      })
      .then(res => res.json())
      .then(novoComponente => {


        // Atualiza a lista local de blocos
        this.blocos.push({
          id: novoBlocoId,
          componente: novoComponente
        });

        // Recarrega a página
        window.location.reload();
      })
      .catch(err => console.error('Erro ao duplicar componente:', err));
    },

    abrirModalAlterarPosicao(componente) {
      if (!componente || !this.calculadorasComPosicao.includes(componente.tipo)) return;

      this.componenteParaAlterarPosicao = componente;
      this.posicaoTemporaria = componente.posicao || this.posicaoPadrao(componente.tipo);

      const modal = document.getElementById('alterarPosicaoComponenteModal');
      if (modal) {
        const instance = Modal.getOrCreateInstance(modal);
        instance.show();
      }
    },

    confirmarAlterarPosicaoComponente() {
      const componente = this.componenteParaAlterarPosicao;
      if (!componente || !this.calculadorasComPosicao.includes(componente.tipo)) return;

      const posicaoAnterior = componente.posicao;
      const novaPosicao = this.posicaoTemporaria;

      componente.posicao = novaPosicao;

      const componenteProjeto = this.projeto.componentes.find(c => c.cod === componente.cod);
      if (componenteProjeto) {
        componenteProjeto.posicao = novaPosicao;
      }

      fetch(`${process.env.VUE_APP_BACKEND_URL}/atualizar-posicao-componente`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          codProjeto: this.projeto.cod,
          codComponente: componente.cod,
          posicao: novaPosicao
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Erro ao atualizar posição');
          }
          return response.json();
        })
        .then(() => {
          this.abrirAlert('Sistema', 'Posição atualizada com sucesso.', 'success');
        })
        .catch(err => {
          console.error('Erro ao alterar posição do componente:', err);
          componente.posicao = posicaoAnterior;
          if (componenteProjeto) {
            componenteProjeto.posicao = posicaoAnterior;
          }
          this.abrirAlert('Sistema', 'Não foi possível alterar a posição do componente.', 'danger');
        })
        .finally(() => {
          this.componenteParaAlterarPosicao = null;
          this.posicaoTemporaria = this.posicaoPadrao(2);
        });
    },

    abrirModalRename(componente) {
      this.componenteSelecionadoParaRenomear = componente;
      this.novoNomeComponente = componente.nomeComponente;
    },

    // Confirmar rename
    confirmarRename() {

      const componente = this.componenteSelecionadoParaRenomear;
      if (!componente) return;

      fetch(`${process.env.VUE_APP_BACKEND_URL}/renomear-componente`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          codProjeto: this.projeto.cod,
          codComponente: componente.cod,
          novoNome: this.novoNomeComponente
        }),
      })
      .then(() => {

        componente.nomeComponente = this.novoNomeComponente; // atualiza localmente
        this.componenteSelecionadoParaRenomear = null;
        this.novoNomeComponente = '';

        window.location.reload();

      })
      .catch(err => console.error("Erro ao renomear componente:", err));
    },

    // IMPRIMIR TODOS OS COMPONENTES DO PROJETO
    
    async carregarCalculo(cod) {

      if (!cod) return null;

      return fetch(
        `${process.env.VUE_APP_BACKEND_URL}/buscar-calculo/${cod}?email=${this.usuarioLogado.email}`
      )
        .then(res => {

          if (res.status === 401 || res.status === 403) {
            this.fecharLoading();
            window.location.href = '/';
            throw new Error('Acesso negado');
          }

          if (!res.ok) {
            throw new Error('Erro ao carregar cálculo');
          }

          return res.json();
        })
        .then(data => {

          if (!data || !data.calculo) {
            throw new Error('Resposta inválida do servidor');
          }

          let retorno = data.calculo;

          if (data.calculo.designData) {
            retorno = data.calculo.designData;
          }

          return retorno;
        })
        .catch(err => {
          console.error('Erro ao carregar cálculo:', err);
          return null;
        });
    },
    
    async carregarDadosComponentesProjetoImprimir() {
      this.abrirLoading();

      try {
        const doc = new jsPDF();

        const totalComponentes = this.projeto.componentes.length + 1; // +1 pelo Design Data

        // Design Data é sempre o componente 1
        const designData = await this.carregarCalculo(this.projeto.designData.cod);
        this.imprimirDesignData(doc, designData, 1, totalComponentes);

        const mapaFuncoes = {
          1: this.imprimirShellCilind,
          2: this.imprimirShellSpherical,
          3: this.imprimirShellConical,
          4: this.imprimirShellEllipsoidal,
          5: this.imprimirTorisphericalHead,
          6: this.imprimirFlangeIntegral,
          7: this.imprimirBocal
        };

        const componentesOrdenados = [...this.projeto.componentes]
          .sort((a, b) => (a.blocoId ?? 9999) - (b.blocoId ?? 9999));

        for (const comp of componentesOrdenados) {
          const metodo = mapaFuncoes[comp.tipo];

          if (!metodo) {
            console.warn(`Tipo não mapeado: ${comp.tipo}`);
            continue;
          }

          const dados = await this.carregarCalculo(comp.cod);

          if (!dados) {
            console.warn(`Dados não encontrados para componente: ${comp.cod}`);
            continue;
          }

          // numeroComponente = blocoId + 1 (pois Design Data é o 1)
          const numeroComponente = comp.blocoId + 1;

          metodo.call(this, doc, dados, numeroComponente, totalComponentes);
        }

        this.salvarPDF(doc);

      } catch (err) {
        console.error('Erro ao gerar PDF:', err);
        this.abrirAlert('Erro', 'Não foi possível gerar o PDF. Tente novamente.', 'danger');
      } finally {
        this.fecharLoading();
      }
    },

    imprimirDesignData(doc, d, numeroComponente, totalComponentes){

      // ------ COMPONENTE 1 - DESIGN DATA ------ //

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      /* =========================
        HELPERS (SEU PADRÃO)
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 10;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        y += 5;
        doc.text(text, 20, y);
        y += 15;
      };

      let field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };

      const message = (text) => {
        checkPage();
        doc.setFont("helvetica", "italic");
        doc.setFontSize(12);
        doc.setTextColor(120);
        doc.text(text, 20, y);
        doc.setTextColor(0);
        y += 8;
      };

      /* =========================
        HEADER
      ========================== */
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;

      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);

      doc.link(logoX, y, logoW, logoH, {
        url: "https://wisecalc.com.br",
      });

      y += logoH + 25;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("Nome do projeto: ", 20, y);

      const larguraLabel = doc.getTextWidth("Nome do projeto: ");

      doc.setFont("helvetica", "normal");
      doc.text(this.projeto.nome || "N/A", 20 + larguraLabel, y);

      y += 20;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text(`Componente ${numeroComponente} de ${totalComponentes}`, 20, y);
      y += 10;
      field("Tipo", "Design Data");
      y += 10;

      field("Autor(a)", this.projeto.autor || "N/A");

      field(
        "Data",
        "",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      message("Os parâmetros abaixo foram utilizados para todos os componentes do projeto.");

      /* =========================
        1. PROJECT INFORMATION
      ========================== */
      y += 10;
      title("1. PROJECT INFORMATION");

      subtitle("GENERAL");

      field("Job name", d.jobName);
      field("Job number", d.jobNumber);
      field("Tag number", d.tagNumber);
      // field("Equipment description", "", d.equipmentDescription);

      // Label
      doc.setFont(undefined, "bold");
      doc.text("Equipment description:", 20, y);

      y += 10;

      // Valor quebrado em múltiplas linhas
      doc.setFont(undefined, "normal");
      const linhas = doc.splitTextToSize(d.equipmentDescription || "-", 180);

      doc.text(linhas, 20, y);

      // Ajusta o Y conforme quantidade de linhas
      y += linhas.length * 6;

      subtitle("DOCUMENT CONTROL");

      field("Client", d.client);
      field("Document number", d.documentNumber);
      field("Prepared by", d.preparedBy);
      field("Checked by", d.checkedBy);
      field("Approved by", d.approvedBy);

      const reviewDate = d.reviewDate
        ? new Date(d.reviewDate).toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : "N/A";

      field("Review date", "", reviewDate);

      /* =========================
        2. VESSEL INFORMATION
      ========================== */
      y += 10;
      title("2. VESSEL INFORMATION");

      subtitle("PRESSURE");
      
      field("Design Internal Pressure", d.designInternalPressure, "MPa");
      field("Max Operation Pressure", d.maxOperationPressure, "MPa");
      field("Design External Pressure", d.designExternalPressure, "MPa");

      subtitle("TEMPERATURE");

      field("Design Temperature", d.designTemperature, "°C");
      field("Room Temperature", d.roomTemperature, "°C");

      subtitle("FLUID");

      field("Fluid", d.fluid);
      field("Density", d.density, "kg/m³");

      subtitle("CONSTRUCTION");

      field("Position", d.position);
      field("Volume", d.volume, "m³");
      field("Corrosion Allowance", d.corrosionAllowance, "mm");
      field("Welded Joint Location", d.weldedJointLocation);
      field("Radiography", d.radiography);
      field("Post Weld Heat Treatment", d.postWeldHeatTreatment);
      field("Fluid Class - Brazilian NR-13", d.fluidClass);
      field("P.V", d.pv, "MPa·m³");
      field("Potential Risk Group (NR-13)", d.potentialRiskGroup);
      field("Category NR-13", d.categoryNR13);

    },

    imprimirShellCilind(doc, f, numeroComponente, totalComponentes){

      doc.addPage();

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      // Header com logo
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;
      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, { url: "https://wisecalc.com.br" });
      y += logoH + 25;

      /* =========================
        HELPERS (SEU PADRÃO)
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 10;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        y += 5;
        doc.text(text, 20, y);
        y += 15;
      };

      let field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };

      // ------ COMPONENTE 2 - SHELL CILIND ------ //

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);

      doc.text(`Componente ${numeroComponente} de ${totalComponentes}`, 20, y);
      y += 10;
      field("Nome", f.nomeCalculo);
      field("Tipo", "Shell Cilind");
      y += 10;

      field("Autor(a)", this.usuarioLogado.nome || "N/A");

      field(
        "Data",
        "",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      y += 10;

      // Shell Cilind
      f = f?.shellCilindInternalPressCalculator || {};

      title("1. DESIGN DATA");

      subtitle("MATERIAL");

      field("Material Specification (ASME II part D)", f.materialSpecification?.materialSpecification);
      field("Nominal Composition", f.nominalComposition);
      field("Product Form", f.productForm);
      field("Alloy Designation/UNS No.", f.alloyDesignation);
      field("Class/Condition/Temper", f.classConditionTemper);
      field("P-No.", f.pNo);
      field("Group No.", f.groupNo);

      subtitle("MECHANICAL PROPERTIES");

      field("Min. Tensile Strength", f.minTensileStrength, " MPa");
      field("Min. Yield Strength", f.minYieldStrength, " MPa");

      subtitle("TEMPERATURE");

      field("VIII-1 Applic. and Max Temp. Limit", f.viiiApplicAndMaxTemLimit, " °C");
      field("Range Design Temperature", f.designTemperature, " °C");

      subtitle("GEOMETRY");

      field("Inside Diameter", f.insideDiameter, " mm");
      field("Liquid Column", f.liquidColumn, " m");
      field("Fluid Density", f.fluidDensity, " kg/m³");

      subtitle("PRESSURE");

      field("Design Pressure on the Top of the Vessel", f.designPressureTop, " MPa");
      field("Design Pressure", f.designPressure, " MPa");

      subtitle("STRESS");

      field("Admissible Stress @ Design Temperature", f.admissibleStressDesignTemp, " MPa");
      field("Admissible Stress @ Room Temperature", f.admissibleStressRoomTemp, " MPa");

      subtitle("DIMENSIONS");

      field("Inside Radius", f.insideRadius, " mm");
      field("Inside Radius Corroded", f.insideRadiusCorroded, " mm");
      field("Corrosion Allowance", f.corrosionAllowance, " mm");
      field("Nominal Thickness minus Corrosion Allowance", f.nominalThicknessMinusCorrosionAloowance, " mm");
      field("Nominal Thickness", f.nominalThickness, " mm");

      subtitle("CONSTRUCTION");

      field("Welded Joint Location", f.weldedJointLocation);

      /* =========================
        2. DESIGN VALIDATION
      ========================== */
      y += 10;
      title("2. DESIGN VALIDATION");
      y += 10;

      let drawingWidth = 80;
      let drawingHeight = 60;
      let drawingX = (pageWidth - drawingWidth) / 2;

      checkPage(drawingHeight + 20);
      doc.addImage(drawingShellCilindInternalPressBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);
      y += drawingHeight + 20;

      subtitle("RESULTS");

      let redIfInvalid = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        if (value === "INVALID NOMINAL THICKNESS") {
          doc.setTextColor(255, 0, 0);
          doc.text(value, x + 2, y);
        } else {
          doc.setTextColor(0, 0, 0);
          doc.text(`${value ?? "N/A"}${unit}`, x + 2, y);
        }

        doc.setTextColor(0, 0, 0);
        y += 10;
      };

      redIfInvalid("Design Thickness", f.designThickness, " mm");
      redIfInvalid("Working Maximum Allowable Pressure", f.workingMaximumAllowablePressure, " MPa");
      redIfInvalid("Hydrostatic Test Pressure", f.hidrostaticTestPressure, " MPa");
      redIfInvalid("Pneumatic Test Pressure", f.pneumaticTestPressure, " MPa");
    },

    imprimirShellSpherical(doc, f, numeroComponente, totalComponentes){

      doc.addPage();

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      // Header com logo
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;
      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, { url: "https://wisecalc.com.br" });
      y += logoH + 25;

      /* =========================
        HELPERS (SEU PADRÃO)
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 10;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        y += 5;
        doc.text(text, 20, y);
        y += 15;
      };

      let field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };
      
      // ------ COMPONENTE 3 - SHELL SPHERICAL ------ //

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text(`Componente ${numeroComponente} de ${totalComponentes}`, 20, y);
      y += 10;
      field("Nome", f.nomeCalculo);
      field("Tipo", "Shell Spherical");
      y += 10;

      field("Autor(a)", this.usuarioLogado.nome || "N/A");

      field(
        "Data",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      y += 10;

      // Shell Spherical
      f = f?.sphericalShellsPressConcaveCalculator || {};

      title("1. DESIGN DATA");

      subtitle("MATERIAL");

      field("Material Specification (ASME II part D)", f.materialSpecification?.materialSpecification);
      field("Nominal Composition", f.nominalComposition);
      field("Product Form", f.productForm);
      field("Alloy Designation/UNS No.", f.alloyDesignation);
      field("Class/Condition/Temper", f.classConditionTemper);
      field("P-No.", f.pNo);
      field("Group No.", f.groupNo);

      subtitle("MECHANICAL PROPERTIES");

      field("Min. Tensile Strength", f.minTensileStrength, " MPa");
      field("Min. Yield Strength", f.minYieldStrength, " MPa");

      subtitle("TEMPERATURE");

      field("VIII-1 Applic. and Max Temp. Limit", f.viiiApplicAndMaxTemLimit, " °C");
      field("Range Design Temperature", f.rangeDesignTemperature, " °C");

      subtitle("GEOMETRY");

      field("Inside Diameter", f.insideDiameter, " mm");
      field("Liquid Column", f.liquidColumn, " m");
      field("Fluid Density", f.fluidDensity, " kg/m³");

      subtitle("PRESSURE");

      field("Design Pressure on the Top of the Vessel", f.designPressureTop, " MPa");
      field("Design Pressure", f.designPressure, " MPa");

      subtitle("STRESS");

      field("Admissible Stress @ Design Temperature", f.admissibleStressDesignTemp, " MPa");
      field("Admissible Stress @ Room Temperature", f.admissibleStressRoomTemp, " MPa");

      subtitle("DIMENSIONS");

      field("Inside Radius", f.insideRadius, " mm");
      field("Inside Radius Corroded", f.insideRadiusCorroded, " mm");
      field("Corrosion Allowance", f.corrosionAllowance, " mm");
      field("Nominal Thickness minus Corrosion Allowance", f.nominalThicknessMinusCorrosionAloowance, " mm");
      field("Nominal Thickness", f.nominalThickness, " mm");

      subtitle("CONSTRUCTION");

      field("Welded Joint Location", f.weldedJointLocation);

      /* =========================
        2. DESIGN VALIDATION
      ========================== */
      y += 10;
      title("2. DESIGN VALIDATION");
      y += 10;

      let drawingWidth = 80;
      let drawingHeight = 60;
      let drawingX = (pageWidth - drawingWidth) / 2;

      checkPage(drawingHeight + 20);
      doc.addImage(drawingSphericalShellsPressConcaveBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);
      y += drawingHeight + 20;

      subtitle("RESULTS");

      let redIfInvalid = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        if (value === "INVALID NOMINAL THICKNESS") {
          doc.setTextColor(255, 0, 0);
          doc.text(value, x + 2, y);
        } else {
          doc.setTextColor(0, 0, 0);
          doc.text(`${value ?? "N/A"}${unit}`, x + 2, y);
        }

        doc.setTextColor(0, 0, 0);
        y += 10;
      };

      redIfInvalid("Design Thickness", f.designThickness, " mm");
      redIfInvalid("Working Maximum Allowable Pressure", f.workingMaximumAllowablePressure, " MPa");
      redIfInvalid("Hydrostatic Test Pressure", f.hidrostaticTestPressure, " MPa");
      redIfInvalid("Pneumatic Test Pressure", f.pneumaticTestPressure, " MPa");

    },

    imprimirShellConical(doc, f, numeroComponente, totalComponentes){

      doc.addPage();

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      // Header com logo
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;
      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, { url: "https://wisecalc.com.br" });
      y += logoH + 25;

      /* =========================
        HELPERS (SEU PADRÃO)
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 10;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        y += 5;
        doc.text(text, 20, y);
        y += 15;
      };

      let field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };

      // ------ COMPONENTE 4 - SHELL CONICAL ------ //

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text(`Componente ${numeroComponente} de ${totalComponentes}`, 20, y);
      y += 10;
      field("Nome", f.nomeCalculo);
      field("Tipo", "Shell Conical");
      y += 10;

      field("Autor(a)", this.usuarioLogado.nome || "N/A");

      field(
        "Data",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      y += 10;

      // Shell Conical
      f = f?.shellConicalInternalPressCalculator || {};

      title("1. DESIGN DATA");

      subtitle("MATERIAL");

      field("Material Specification (ASME II part D)", f.materialSpecification?.materialSpecification);
      field("Nominal Composition", f.nominalComposition);
      field("Product Form", f.productForm);
      field("Alloy Designation/UNS No.", f.alloyDesignation);
      field("Class/Condition/Temper", f.classConditionTemper);
      field("P-No.", f.pNo);
      field("Group No.", f.groupNo);

      subtitle("MECHANICAL PROPERTIES");

      field("Min. Tensile Strength", f.minTensileStrength, " MPa");
      field("Min. Yield Strength", f.minYieldStrength, " MPa");

      subtitle("TEMPERATURE");

      field("VIII-1 Applic. and Max Temp. Limit", f.viiiApplicAndMaxTemLimit, " °C");
      field("Range Design Temperature", f.rangeDesignTemperature, " °C");

      subtitle("GEOMETRY");

      field("Inside Diameter", f.insideDiameter, " mm");
      field("Liquid Column", f.liquidColumn, " m");
      field("Fluid Density", f.fluidDensity, " kg/m³");

      subtitle("PRESSURE");

      field("Design Pressure on the Top of the Vessel", f.designPressureTop, " MPa");
      field("Design Pressure", f.designPressure, " MPa");

      subtitle("STRESS");

      field("Admissible Stress @ Design Temperature", f.admissibleStressDesignTemp, " MPa");
      field("Admissible Stress @ Room Temperature", f.admissibleStressRoomTemp, " MPa");

      subtitle("DIMENSIONS");

      field("Inside Radius", f.insideRadius, " mm");
      field("Inside Radius Corroded", f.insideRadiusCorroded, " mm");
      field("Corrosion Allowance", f.corrosionAllowance, " mm");
      field("Nominal Thickness minus Corrosion Allowance", f.nominalThicknessMinusCorrosionAloowance, " mm");
      field("Nominal Thickness", f.nominalThickness, " mm");

      subtitle("CONSTRUCTION");

      field("Welded Joint Location", f.weldedJointLocation);

      /* =========================
        2. DESIGN VALIDATION
      ========================== */
      y += 10;
      title("2. DESIGN VALIDATION");

      let drawingWidth = 80;
      let drawingHeight = 60;
      let drawingX = (pageWidth - drawingWidth) / 2;

      checkPage(drawingHeight + 20);
      doc.addImage(drawingShellConicalInternalPressBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);
      y += drawingHeight + 20;

      subtitle("RESULTS");

      let redIfInvalid = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        if (value === "INVALID NOMINAL THICKNESS") {
          doc.setTextColor(255, 0, 0);
          doc.text(value, x + 2, y);
        } else {
          doc.setTextColor(0, 0, 0);
          doc.text(`${value ?? "N/A"}${unit}`, x + 2, y);
        }

        doc.setTextColor(0, 0, 0);
        y += 10;
      };

      redIfInvalid("Design Thickness", f.designThickness, " mm");
      redIfInvalid("Working Maximum Allowable Pressure", f.workingMaximumAllowablePressure, " MPa");
      redIfInvalid("Hydrostatic Test Pressure", f.hidrostaticTestPressure, " MPa");
      redIfInvalid("Pneumatic Test Pressure", f.pneumaticTestPressure, " MPa");

    },

    imprimirShellEllipsoidal(doc, f, numeroComponente, totalComponentes){

      doc.addPage();

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      // Header com logo
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;
      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, { url: "https://wisecalc.com.br" });
      y += logoH + 25;

      /* =========================
        HELPERS (SEU PADRÃO)
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 10;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        y += 5;
        doc.text(text, 20, y);
        y += 15;
      };

      let field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };

      // ------ COMPONENTE 5 - SHELL ELLIPSOIDAL ------ //

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text(`Componente ${numeroComponente} de ${totalComponentes}`, 20, y);
      y += 10;
      field("Nome", f.nomeCalculo);
      field("Tipo", "Shell Ellipsoidal");
      y += 10;

      field("Autor(a)", this.usuarioLogado.nome || "N/A");

      field(
        "Data",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      y += 10;

      // Shell Elipsoidal
      f = f?.ellipsoidalHeadPressConcaveCalculator || {};

      title("1. DESIGN DATA");

      subtitle("MATERIAL");

      field("Material Specification (ASME II part D)", f.materialSpecification?.materialSpecification);
      field("Nominal Composition", f.nominalComposition);
      field("Product Form", f.productForm);
      field("Alloy Designation/UNS No.", f.alloyDesignation);
      field("Class/Condition/Temper", f.classConditionTemper);
      field("P-No.", f.pNo);
      field("Group No.", f.groupNo);

      subtitle("MECHANICAL PROPERTIES");

      field("Min. Tensile Strength", f.minTensileStrength, "MPa");
      field("Min. Yield Strength", f.minYieldStrength, "MPa");

      subtitle("TEMPERATURE");

      field("VIII-1 Applic. and Max Temp. Limit", f.viiiApplicAndMaxTemLimit, "°C");
      field("Range Design Temperature", f.rangeDesignTemperature, "°C");

      subtitle("GEOMETRY");

      field("Inside Diameter", f.insideDiameter, "mm");
      field("Liquid Column", f.liquidColumn, "m");
      field("Fluid Density", f.fluidDensity, "kg/m³");

      subtitle("PRESSURE");

      field("Design Pressure on the Top of the Vessel", f.designPressureTop, "MPa");
      field("Design Pressure", f.designPressure, "MPa");

      subtitle("STRESS");

      field("Admissible Stress @ Design Temperature", f.admissibleStressDesignTemp, "MPa");
      field("Admissible Stress @ Room Temperature", f.admissibleStressRoomTemp, "MPa");

      subtitle("DIMENSIONS");

      field("Inside Radius", f.insideRadius, "mm");
      field("Inside Radius Corroded", f.insideRadiusCorroded, "mm");
      field("Corrosion Allowance", f.corrosionAllowance, "mm");
      field("Nominal Thickness minus Corrosion Allowance", f.nominalThicknessMinusCorrosionAloowance, "mm");
      field("Nominal Thickness", f.nominalThickness, "mm");

      subtitle("CONSTRUCTION");

      field("Welded Joint Location", f.weldedJointLocation);

      /* =========================
        2. DESIGN VALIDATION
      ========================== */
      y += 10;
      title("2. DESIGN VALIDATION");
      y += 10;

      // imagem
      let drawingWidth = 80;
      let drawingHeight = 60;
      let drawingX = (pageWidth - drawingWidth) / 2;

      checkPage(drawingHeight + 20);
      doc.addImage(drawingEllipsoidalHeadPressConcaveBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);
      y += drawingHeight + 20;

      subtitle("RESULTS");

      let redIfInvalid = (value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.text(value.label, 20, y);

        let x = 20 + doc.getTextWidth(value.label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        if (value.val === "INVALID NOMINAL THICKNESS") {
          doc.setTextColor(255, 0, 0);
          doc.text(value.val, x + 2, y);
        } else {
          doc.setTextColor(0, 0, 0);
          doc.text(`${value.val ?? "N/A"}${unit}`, x + 2, y);
        }

        doc.setTextColor(0, 0, 0);
        y += 10;
      };

      redIfInvalid(
        { label: "Design Thickness", val: f.designThickness },
        " mm"
      );

      redIfInvalid(
        { label: "Working Maximum Allowable Pressure", val: f.workingMaximumAllowablePressure },
        " MPa"
      );

      redIfInvalid(
        { label: "Hydrostatic Test Pressure", val: f.hidrostaticTestPressure },
        " MPa"
      );

      redIfInvalid(
        { label: "Pneumatic Test Pressure", val: f.pneumaticTestPressure },
        " MPa"
      );

    },

    imprimirTorisphericalHead(doc, f, numeroComponente, totalComponentes){

      doc.addPage();

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      // Header com logo
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;
      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, { url: "https://wisecalc.com.br" });
      y += logoH + 25;

      /* =========================
        HELPERS (SEU PADRÃO)
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 10;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        y += 5;
        doc.text(text, 20, y);
        y += 15;
      };

      let field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };

      // ------ COMPONENTE 6 - TORISPLE HEAD ------ //

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text(`Componente ${numeroComponente} de ${totalComponentes}`, 20, y);
      y += 10;
      field("Nome", f.nomeCalculo);
      field("Tipo", "Shell Torispherical Head");
      y += 10;

      field("Autor(a)", this.usuarioLogado.nome || "N/A");

      field(
        "Data",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      y += 10;

      // Torispherical Head
      f = f?.torispleHeadPressConcaveCalculator || {};
    
      title("1. DESIGN DATA");

      subtitle("MATERIAL");

      field("Material Specification (ASME II part D)", f.materialSpecification?.materialSpecification);
      field("Nominal Composition", f.nominalComposition);
      field("Product Form", f.productForm);
      field("Alloy Designation/UNS No.", f.alloyDesignation);
      field("Class/Condition/Temper", f.classConditionTemper);
      field("P-No.", f.pNo);
      field("Group No.", f.groupNo);

      subtitle("MECHANICAL PROPERTIES");

      field("Min. Tensile Strength", f.minTensileStrength, " MPa");
      field("Min. Yield Strength", f.minYieldStrength, " MPa");

      subtitle("TEMPERATURE");

      field("VIII-1 Applic. and Max Temp. Limit", f.viiiApplicAndMaxTemLimit, " °C");
      field("Range Design Temperature", f.rangeDesignTemperature, " °C");

      subtitle("GEOMETRY");

      field("Inside Diameter", f.insideDiameter, " mm");
      field("Liquid Column", f.liquidColumn, " m");
      field("Fluid Density", f.fluidDensity, " kg/m³");

      subtitle("PRESSURE");

      field("Design Pressure on the Top of the Vessel", f.designPressureTop, " MPa");
      field("Design Pressure", f.designPressure, " MPa");

      subtitle("STRESS");

      field("Admissible Stress @ Design Temperature", f.admissibleStressDesignTemp, " MPa");
      field("Admissible Stress @ Room Temperature", f.admissibleStressRoomTemp, " MPa");

      subtitle("DIMENSIONS");

      field("Inside Radius", f.insideRadius, " mm");
      field("Inside Radius Corroded", f.insideRadiusCorroded, " mm");
      field("Corrosion Allowance", f.corrosionAllowance, " mm");
      field("Nominal Thickness minus Corrosion Allowance", f.nominalThicknessMinusCorrosionAloowance, " mm");
      field("Nominal Thickness", f.nominalThickness, " mm");

      subtitle("CONSTRUCTION");

      field("Welded Joint Location", f.weldedJointLocation);

      /* =========================
        2. DESIGN VALIDATION
      ========================== */

      y += 10;
      title("2. DESIGN VALIDATION");
      y += 10;

      let drawingWidth = 80;
      let drawingHeight = 60;
      let drawingX = (pageWidth - drawingWidth) / 2;

      checkPage(drawingHeight + 20);
      doc.addImage(drawingTorispleHeadPressConcaveBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);
      y += drawingHeight + 20;

      subtitle("RESULTS");

      let redIfInvalid = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        if (value === "INVALID NOMINAL THICKNESS") {
          doc.setTextColor(255, 0, 0);
          doc.text(value, x + 2, y);
        } else {
          doc.setTextColor(0, 0, 0);
          doc.text(`${value ?? "N/A"}${unit}`, x + 2, y);
        }

        doc.setTextColor(0, 0, 0);
        y += 10;
      };

      redIfInvalid("Design Thickness", f.designThickness, " mm");
      redIfInvalid("Working Maximum Allowable Pressure", f.workingMaximumAllowablePressure, " MPa");
      redIfInvalid("Hydrostatic Test Pressure", f.hidrostaticTestPressure, " MPa");
      redIfInvalid("Pneumatic Test Pressure", f.pneumaticTestPressure, " MPa");

    },

    imprimirFlangeIntegral(doc, f, numeroComponente, totalComponentes){

      doc.addPage(); // ← página nova, limpa
      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      // Header com logo
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;
      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, { url: "https://wisecalc.com.br" });
      y += logoH + 25;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      /* =========================
        HELPERS (SEU PADRÃO)
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 10;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        y += 5;
        doc.text(text, 20, y);
        y += 15;
      };

      let field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };

      const message = (text) => {
        checkPage();
        doc.setFont("helvetica", "italic");
        doc.setFontSize(12);
        doc.setTextColor(120);
        doc.text(text, 20, y);
        doc.setTextColor(0);
        y += 8;
      };

      // ------ COMPONENTE 7 - FLANGE INTEGRAL ------ //

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text(`Componente ${numeroComponente} de ${totalComponentes}`, 20, y);
      y += 10;
      field("Nome", f.nomeCalculo);
      field("Tipo", "Flange Integral");
      y += 10;

      field("Autor(a)", this.usuarioLogado.nome || "N/A");

      field(
        "Data",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      y += 10;

      // Flange Integral
      f = f?.flangeIntegralCalculator || {};

      /* =========================
        1. PRE-CONFIGURATION
      ========================== */

      title("1. PRE-CONFIGURATION");
      y += 10;
      field("Overbolting", "", f.overboltingSelect === "1" ? "Yes" : "No");
      field("Replace B by B1", "", f.bSelect === "1" ? "Yes" : "No");

      /* =========================
        2. FLANGE MATERIAL
      ========================== */
      y += 10;
      title("2. FLANGE MATERIAL");
      field("Flange Material", "", f.flangeMaterial);
      field("Bolt Material", "", f.boltMaterial);
      field("Gasket", "", f.gasket);

      /* =========================
        3. DESIGN DATA
      ========================== */
      y += 10;
      title("3. DESIGN DATA");
      field("Design Pressure (Internal)", "P", f.designPressureInternal, "MPa");
      field("Design Temperature", "Tp", f.designTemperature, "°C");
      field("Corrosion Allowance", "c", f.corrosionAllowance, "mm");
      field("Shell Allowable Stress", "Sn", f.shellAllowStress, "N/mm²");
      field("At Atmospheric Temp", "Sna", f.atmosphericTemp, "N/mm²");

      /* =========================
        4. FLANGE ALLOWABLE STRESS
      ========================== */
      y += 10;
      title("4. FLANGE ALLOWABLE STRESS");
      field("At Design Temp", "Sfo", f.sfo, "N/mm²");
      field("At Atmospheric Temp", "Sfa", f.sfa, "N/mm²");

      /* =========================
        5. BOLTING ALLOWABLE STRESS
      ========================== */
      y += 10;
      title("5. BOLTING ALLOWABLE STRESS");
      field("At Design Temp", "Sbo", f.sbo, "N/mm²");
      field("At Atmospheric Temp", "Sba", f.sba, "N/mm²");

      /* =========================
        6. FLANGE
      ========================== */
      y += 10;
      title("6. FLANGE");
      field("OD Flange", "A", f.odFlange, "mm");
      field("ID Flange", "B", f.idFlange, "mm");
      field("Center Bolt Diameter", "C", f.centerBoltDiameter, "mm");
      field("Load Reaction Gasket Diameter", "G", f.loadReactionGasketDiameter, "mm");
      field("Thickness Hub Small End", "g0", f.thicknessHubSmallEnd, "mm");
      field("Thickness Hub Back", "g1", f.thicknessHubBack, "mm");
      message("B > 20 g1");
      field("Hub Length", "h", f.hubLength, "mm");
      field("R", "R", f.R, "mm");
      field("f", "f", f.f);
      message("B = B1 + g1");
      field("B1", "B1", f.b1);
      message("Não será utilizado p/ calcular SH");
      field("Minimum Gasket Width", "Nmin", f.larguraMinimaJunta, "mm");

      /* =========================
        7. BOLTING
      ========================== */
      y += 10;
      title("7. BOLTING");
      field("Bolt Diameter", "d", f.boltDiameter, "in");
      field("Pitch Diameter", "Dp", f.pitchDiameter);
      field("Bolts Quantity", "n", f.boltsQuantity);
      field("Stress Area", "", f.rootDiameter, "mm²");
      field("Friction Factor", "", f.frictionFactor);
      field("Minimum Torque", "", f.torqueMinimo, "N·m");
      field("Maximum Torque", "", f.torqueMaximo, "N·m");

      /* =========================
        8. GASKET
      ========================== */
      y += 10;
      title("8. GASKET");
      field("OD Gasket", "", f.odGasket, "mm");
      field("ID Gasket", "", f.idGasket, "mm");
      field("Max Gasket Crushing Pressure", "", f.gasketCrushingPressure, "N/mm²");
      field("Ag", "", f.Ag, "mm²");
      field("Sya", "", f.Sya, "N/mm²");
      field("Sys", "", f.Sys, "N/mm²");
      field("Result Gasket", "", f.resultGasket);

      /* =========================
        9. PARAMETERS
      ========================= */
      y += 10;
      title("9. PARAMETERS");

      field("(od - id) / 2", "N", f.N, "mm");
      field("N / 2", "b0", f.b0, "mm");
      field("min.(b0, 2.5√(b0 × 1/2))", "b", f.b, "mm");
      field("Gasket factor", "y", f.y, "N/mm²");
      field("m factor", "m", f.m);
      
      /* =========================
        10. CALCULATED VALUES
      ========================= */
      y += 10;
      title("10. CALCULATED VALUES");

      field("3.14 b G y", "Wm2", f.Wm2, "N");
      field("6.28 b G m p", "Hp", f.Hp, "N");
      field("0.785 G² p", "H", f.H, "N");
      field("Hp + H", "Wm1", f.Wm1, "N");
      field("max(Wm2/Sba, Wm1/Sbo)", "Am", f.Am, "mm²");
      field("Bolts qty × root area", "Ab", f.Ab, "mm²");
      field("(Am + Ab) × Sba / 2", "W1", f.W1, "N");
      field("(Ab × Sba)", "W2", f.W2, "N");
      field("max(W1, W2)", "W", f.W, "N");

      /* =========================
        11. OPERATING CONDITIONS
      ========================= */
      y += 10;
      title("11. OPERATING CONDITIONS");

      subtitle("FLANGE LOADS");

      field("0.785 B² P", "Hd", f.Hd, "N");
      field("W - H", "Hg", f.Hg, "N");
      field("H - Hd", "Ht", f.Ht, "N");

      subtitle("LEVER ARMS");

      field("R + 0.5 g1", "hd", f.hd, "mm");
      field("(C - G) / 2", "hg", f.hg, "mm");
      field("(R + g1 + hg) / 2", "ht", f.ht, "mm");

      subtitle("FLANGE MOMENTS");

      field("Hd × hd", "Md", f.Md, "N·mm");
      field("Hg × hg", "Mg", f.Mg, "N·mm");
      field("Ht × ht", "Mt", f.Mt, "N·mm");
      field("Md + Mg + Mt", "Mop", f.Mop, "N·mm");

      /* =========================
        12. ATMOSPHERIC CONDITIONS
      ========================= */
      y += 10;
      title("12. ATMOSPHERIC CONDITIONS");

      subtitle("FLANGE LOAD");

      field("W", "Hg", f.Hg2, "N");

      subtitle("LEVER ARM");

      field("(C - G) / 2", "hg", f.hg2, "mm");

      subtitle("FLANGE MOMENT");

      field("Hg × hg", "Matm", f.Matm, "N·mm");

      subtitle("TOTAL MOMENTS ON FLANGE");

      field("Bolt correction factor", "CF", f.CF);
      field("Moment at operative condition (Mop × CF / B)", "Mo", f.Mo, "N·mm");
      field("Moment at atmospheric condition (Matm × CF / B)", "Ma", f.Ma, "N·mm");

      /* =========================
        13. SHAPE CONSTANTS
      ========================= */
      y += 10;
      title("13. SHAPE CONSTANTS");

      field("A / B", "K", f.K);
      field("fig. 2-7.1", "T", f.T);
      field("fig. 2-7.1", "Z", f.Z);
      field("Y", "Y", f.Y);
      field("U", "U", f.U);
      field("g1 / g0", "g1g0", f.g1g0);
      field("sqrt(B g0)", "h0", f.h0);
      field("h / h0", "hh0", f.hh0);
      field("fig. 2-7.2", "F", f.F);
      field("fig. 2-7.3", "V", f.V);
      field("fig. 2-7.6", "f", f.fShape);
      field("F / h0", "e", f.e);
      field("(U / V) h0 g0²", "d", f.d);
      field("t", "t", f.t);
      field("β = (1.33 t e + 1)", "beta", f.beta);
      field("(t e + 1) / T + (3 / d)", "L", f.L);

      /* =========================
        14. STRESS CALCULATIONS
      ========================= */
      y += 10;
      title("14. STRESS CALCULATIONS");

      subtitle("OPERATING CONDITION");

      field("Longitudinal hub stress SH = (f Mo) / (L t² B)", "SH", f.SH_operating, "MPa");
      field("Radial flange stress SR = (β Mo) / (L t² B)", "SR", f.SR_operating, "MPa");
      field("Tangent flange stress ST = (y Mo) / (t² B) - Z SR", "ST", f.ST_operating, "MPa");
      field("Max of 0.5 × (SH + SR) or 0.5 × (SH + ST)", "Smax", f.Smax_operating, "MPa");

      subtitle("AMBIENT CONDITION");

      field("Longitudinal hub stress SH (ambient)", "SH", f.SH_ambient, "MPa");
      field("Radial flange stress SR (ambient)", "SR", f.SR_ambient, "MPa");
      field("Tangent flange stress ST (ambient)", "ST", f.ST_ambient, "MPa");
      field("Max of 0.5 × (SH + SR) or 0.5 × (SH + ST)", "Smax", f.Smax_ambient, "MPa");

      subtitle("DRAWING");

      let drawingWidth = 130;
      let drawingHeight = 80;
      let drawingX = (pageWidth - drawingWidth) / 2;

      checkPage(drawingHeight + 20);
      doc.addImage(drawingFlangeIntegralBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);

      y += drawingHeight;

    },

    imprimirBocal(doc, f, numeroComponente, totalComponentes){

      doc.addPage();
      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      // Header com logo
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;
      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, { url: "https://wisecalc.com.br" });
      y += logoH + 25;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      /* =========================
        HELPERS (SEU PADRÃO)
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 10;
      };

      const subtitle = (text) => {
        checkPage();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        y += 5;
        doc.text(text, 20, y);
        y += 15;
      };

      let field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };

      // ------ COMPONENTE 8 - BOCAL ------ //

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text(`Componente ${numeroComponente} de ${totalComponentes}`, 20, y);
      y += 10;
      field("Nome", f.nomeCalculo);
      field("Tipo", "Bocal");
      y += 10;

      field("Autor(a)", this.usuarioLogado.nome || "N/A");

      field(
        "Data",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      y += 10;

      // Bocal
      f = f?.bocalCalculator || {};

      /* =========================
        1. GENERAL SETTINGS
      ========================== */
      title("1. GENERAL SETTINGS");

      field("Nozzle over shell weld", f.soldaCostado === "1" ? "Yes" : "No");

      /* =========================
        2. PROJECT DATA
      ========================== */
      y += 10;
      title("2. PROJECT DATA");

      field("Design pressure (P)", f.pressaoProjeto, " MPa");
      field("Design temperature (T)", f.temperaturaProjeto, " °C");
      field("Opening internal diameter (d)", f.diametroInternoAbertura, " mm");
      field("Shell internal diameter (D)", f.diametroInternoCasco, " mm");

      /* =========================
        3. EFFICIENCY AND CORROSION
      ========================== */
      y += 10;
      title("3. EFFICIENCY AND CORROSION");

      field("Nozzle welded joint efficiency (En)", f.eficienciaJuntaBocal);
      field("Shell welded joint efficiency (Ev)", f.eficienciaJuntaCasco);
      field("Nozzle corrosion allowance (Can)", f.corrosaoAdmissivelBocal, " mm");
      field("Head or Shell corrosion allowance (Cav)", f.corrosaoAdmissivelCasco, " mm");
      field("Corroded nozzle internal radius (Rn)", f.raioInternoBocalCorroido, " mm");
      field("Reinforcement pad thickness (te)", f.espessuraChapaReforco, " mm");
      field("Allowable stress of reinforcement pad (Se)", f.tensaoAdmissivelChapaReforco, " MPa");
      field("Reinforcement pad diameter (Dp)", f.diametroChapaReforco, " mm");

      /* =========================
        4. MATERIAL DATA
      ========================== */
      y += 10;
      title("4. MATERIAL DATA");

      subtitle("SHELL");

      field("Material", f.materialCasco);
      field("Allowable stress at design temperature (Sv)", f.tensaoAdmissivelCasco, " MPa");
      field("Minimum required thickness", f.espessuraMinimaCasco, " mm");
      field("Nominal thickness", f.espessuraNominalCasco, " mm");
      field("Corroded thickness", f.espessuraCorroidaCasco, " mm");

      subtitle("NOZZLE");

      field("Material", f.materialSpecification?.materialSpecification);
      field("Allowable stress at design temperature (Sn)", f.tensaoAdmissivelBocal, " MPa");
      field("Minimum required thickness", f.espessuraMinimaBocal, " mm");
      field("Nominal thickness", f.espessuraNominalBocal, " mm");
      field("Corroded thickness", f.espessuraCorroidaBocal, " mm");

      /* =========================
        5. UG-41 LIMITS
      ========================== */
      y += 10;
      title("5. UG-41 LIMITS");

      field("2(d + 2Can)", f.calculo2dMais2Can, " mm");
      field("2(Rn + tn + tv)", f.calculo2RnMaisTnMaisTv, " mm");
      field("Limit diameter (DL)", f.DL, " mm");

      field("2.5tv", f.calculo2ponto5Tv, " mm");
      field("2.5tn + te", f.calculo2ponto5TnMaisTe, " mm");
      field("Limit thickness (TLNP)", f.TLNP, " mm");

      field("Stress ratio Sn/Sv", f.razaoSnSv);
      field("Minimum ratio (Sn/Sv or Sr/Sv)", f.menorSnSvSrSv);
      field("Stress ratio Se/Sv", f.razaoSeSv);
      field("Correction factor (F)", f.fatorCorrecao);

      /* =========================
        6. REINFORCEMENT AREAS
      ========================== */
      y += 10;
      title("6. REINFORCEMENT AREAS");

      field("Required reinforcement area (AR)", f.areaRequerida, " mm²");
      field("Available reinforcement area in shell (A1)", f.A1, " mm²");
      field("Weld area (A2)", f.A2, " mm²");
      field("External weld area (A41)", f.areaSoldaExterna, " mm²");
      field("Pad/Shell weld area (A42)", f.areaSoldaPadCostado, " mm²");
      field("Internal weld area (A43)", f.areaSoldaInterna, " mm²");
      field("Nozzle penetration area (A3)", f.areaBocalPenetraCasco, " mm²");
      field("Reinforcement pad area (A5)", f.areaChapaReforco, " mm²");
      field("Total reinforcement area (AT)", f.areaTotalReforco, " mm²");
      field("Reinforcement check result", f.resultadoRefoço);

      /* =========================
        7. RESULT
      ========================== */
      y += 10;
      title("7. RESULT");

      field("Final verification result", f.resultado);

      /* =========================
        8. WELD LOADS
      ========================== */
      y += 10;
      title("8. WELD LOADS");

      field("Total load on welds (F)", f.cargaTotalSoldas, " N");
      field("Load on failure line 1-1 (F1)", f.cargaLinhaFalha11, " N");
      field("Load on failure line 2-2 (F2)", f.cargaLinhaFalha22, " N");
      field("Load on failure line 3-3 (F3)", f.cargaLinhaFalha33, " N");

      /* =========================
        9. RESISTANCE
      ========================== */
      y += 10;
      title("9. RESISTANCE");

      field("Allowable weld stress (S)", f.tensaoAdmissivelSoldas, " MPa");
      field("Shear stress weld pad/shell (R1)", f.cisalhamentoSoldaPadCasco, " N");
      field("Shear stress weld nozzle/pad (R2)", f.cisalhamentoSoldaBocalPad, " N");
      field("Tensile stress weld pad/shell (R3)", f.tracaoSoldaTopoPadCasco, " N");
      field("Tensile stress weld shell/nozzle (R4)", f.tracaoSoldaTopoCascoBocal, " N");
      field("Nozzle resistance (R5)", f.resistenciaBocal, " N");
      field("Reinforcement pad resistance (R6)", f.resistenciaChapaReforco, " N");

      /* =========================
        10. FAILURE LINES
      ========================== */
      y += 10;
      title("10. FAILURE LINE STRENGTH");

      field("Failure line resistance 1-1 (R11)", f.resistenciaLinha11, " N");
      field("Verification result 1-1", f.resultadoLinha11);

      field("Failure line resistance 2-2 (R22)", f.resistenciaLinha22, " N");
      field("Verification result 2-2", f.resultadoLinha22);

      field("Failure line resistance 3-3 (R33)", f.resistenciaLinha33, " N");
      field("Verification result 3-3", f.resultadoLinha33);

      field("Reinforcement pad verification", f.resultadoChapaReforco);

      /* =========================
        11. FLANGE DATA
      ========================== */
      y += 10;
      title("11. FLANGE DATA");

      field("Flange material", f.materialFlange);
      field("Pressure rating", f.pressureRating);
      field("Working allowable pressure (WAMP)", f.wamp, " MPa");

      /* =========================
        12. UG-45
      ========================== */
      y += 10;
      title("12. MINIMUM NOZZLE THICKNESS (UG-45)");

      field("Design pressure (P)", f.pressaoProjeto, " MPa");
      field("Allowable stress (S)", f.tensaoAdmissivelBocal, " MPa");
      field("External diameter of nozzle (De)", f.externalRadiusNozzle, " mm");
      field("Weld efficiency (E)", f.eficienciaJuntaBocal);
      field("Corrosion allowance (CA)", f.corrosaoAdmissivelBocal, " mm");
      field("Calculated thickness (ta)", f.thicknessTa, " mm");
      field("UG-45 thickness requirement", f.ug45, " mm");
      field("Minimum required thickness (t)", f.minThicknessUG45, " mm");

      subtitle("DRAWING");

      let drawingWidth = 100;
      let drawingHeight = 80;
      let drawingX = (pageWidth - drawingWidth) / 2;

      checkPage(drawingHeight + 20);
      doc.addImage(drawingBocalBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);

      y += drawingHeight + 20;

    },

    adicionarPaginacao(doc) {
      const totalPaginas = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.height;

      for (let i = 1; i <= totalPaginas; i++) {
        doc.setPage(i);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(150);

        const texto = `Página ${i} de ${totalPaginas}`;
        const textWidth = doc.getTextWidth(texto);
        doc.text(texto, (pageWidth - textWidth) / 2, pageHeight - 10);

        doc.setTextColor(0);
      }
    },

    salvarPDF(doc) {
      this.adicionarPaginacao(doc);
      doc.save(`(WISECALC) ${this.projeto.nome}.pdf`);
    },

  }
}
</script>

<style>
#container { min-width: 60%; max-width: 80%; }

.cabecalho-projeto-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  overflow-x: auto;
  margin: 24px 0;
  padding: 24px 0;
}

.breadcrumb-projeto {
  flex: 0 0 auto;
  margin: 0;
}

.breadcrumb-projeto .breadcrumb {
  margin: 0;
}

.projeto-badges {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.projeto-badges .badge {
  margin: 0 !important;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .cabecalho-projeto-meta {
    align-items: flex-start;
    flex-direction: column;
    overflow-x: visible;
  }
}

.nome-projeto-titulo {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #172033;
  font-weight: 800;
  font-size: clamp(1.75rem, 3vw, 2.25rem);
}

.titulo-secao-projeto {
  color: #172033;
  font-weight: 700;
  font-size: 1rem;
}

.projeto-cabecalho {
  margin: 24px 0 24px;
  padding-bottom: 24px;
  border-bottom: none;
}

.projeto-cabecalho .page-header-eyebrow {
  margin-bottom: 0px;
}

.projeto-cabecalho .nome-projeto-titulo {
  margin: 0;
}

.projeto-acao {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  padding: 0 0 16px;
  border-bottom: 1px solid #e6ecf5;
}

.descricao-secao-projeto {
  margin: 0;
  color: #596579;
  font-size: 0.875rem;
  line-height: 1.55;
}

.projeto-acao .btn {
  min-width: 120px;
}

.projeto-secao {
  margin-left: 0;
  margin-right: 0;
}

.projeto-design-data-acao {
  margin-top: 16px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e6ecf5;
}

.tabela-componentes {
  width: 100%;
  min-width: 980px;
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
  background: transparent;
}

.tabela-componentes-container {
  margin-top: 3rem;
  overflow-x: auto;
  border: 1px solid #EDEFF2;
  border-radius: 12px;
  background: #ffffff;
}

.tabela-componentes thead th {
  padding: 12px 14px;
  border-bottom: 1px solid #EDEFF2;
  color: #6B7280;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  background: #F8FAFC;
  vertical-align: middle;
}

.tabela-componentes tbody tr {
  background: #ffffff;
}

.tabela-componentes tbody tr:hover {
  background: #f4f8ff;
}

.tabela-componentes tbody td:has(.dropdown-menu.show) {
  position: relative;
  z-index: 10;
}

.tabela-componentes tbody td {
  padding: 12px 14px;
  border-bottom: 1px solid #EDEFF2;
  color: #2e3a4d;
  font-size: 0.82rem;
  line-height: 1.4;
  vertical-align: middle;
}

.tabela-componentes tbody tr:last-child td { border-bottom: 0; }
.tabela-componentes tbody tr:last-child td:first-child { border-bottom-left-radius: 12px; }
.tabela-componentes tbody tr:last-child td:last-child { border-bottom-right-radius: 12px; }
.tabela-componentes thead th:first-child { border-top-left-radius: 11px; }
.tabela-componentes thead th:last-child { border-top-right-radius: 11px; }

.tabela-componentes td:nth-child(2),
.tabela-componentes td:nth-child(3) {
  max-width: 220px;
  white-space: normal;
  word-break: break-word;
}

.tabela-componentes .btn-group {
  display: inline-flex;
  align-items: center;
}

.tabela-componentes .btn {
  white-space: nowrap;
}

.blocos-grid .bloco {
  min-height: 180px;
  padding: 16px;   
  height: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.blocos-grid .bloco[draggable="true"] {
  cursor: grab;
}

.blocos-grid .bloco[draggable="true"]:active {
  cursor: grabbing;
}

.blocos-grid .bloco:hover {
  background-color: #e2e6ea;
  transform: none;
}

/* Estilos para arrastar - DO PRIMEIRO EXEMPLO */
.bloco.arrastando {
  opacity: 0.5;
  border: 2px dashed #007bff !important;
  background-color: #e3f2fd !important;
}

.col-12.col-md-4.sobreposto .bloco,
.col-12.col-md-3.sobreposto .bloco {
  border: 2px solid #007bff !important;
  background-color: #d4e6f8 !important;
}

.bloco-arrastando {
  transform: scale(0.95);
}

.titulo-componente {
  display: block;
  width: 100%;
  color: inherit;
  text-align: center;
  text-decoration: none;
}

.titulo-componente:hover {
  color: inherit;
  text-decoration: none;
}

/* Feedback visual durante o drop */
.col-12.col-md-4.sobreposto::before,
.col-12.col-md-3.sobreposto::before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
  pointer-events: none;
}

.col-12.col-md-4.sobreposto .bloco,
.col-12.col-md-3.sobreposto .bloco {
  opacity: 0.8;
}

/* Estilo para o botão de menu */
.bloco .btn-outline-secondary {
  padding: 0.125rem 0.25rem;
  font-size: 0.75rem;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.bloco .btn-outline-secondary:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.05);
}

.btn-outline-danger:hover,
.btn-outline-danger:focus,
.btn-outline-danger:active {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
  color: #fff !important;
}

/* Garantir que o menu fique acima do conteúdo */
.bloco .dropdown-menu {
  position: absolute !important;
  right: 0;
  left: auto;
  top: calc(100% + 4px);
  z-index: 1050;
}

/* Melhorar a aparência dos ícones no menu */
.dropdown-item i {
  width: 16px;
  text-align: center;
}

/* Quando o dropdown do bloco estiver aberto, elevar o bloco inteiro */
.bloco:has(.dropdown-menu.show) {
  z-index: 20;
}

/* Garantir que o dropdown fique acima de tudo */
.bloco .dropdown-menu {
  z-index: 30;
}

.img-componente {
  max-width: 132px;
  max-height: 132px;
  object-fit: contain;
}

.casco-vertical {
  width: 100%;
}

.casco-bloco-vertical .img-componente {
  transform: rotate(90deg);
  transform-origin: center center;
}

.calculator-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}

.calculator-card {
  border: 2px solid #dee2e6;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
}

.calculator-card:hover {
  border-color: #007bff;
  transform: translateY(-2px);
}

.calculator-card.selected {
  border-color: #007bff;
  background: #e7f1ff;
}

.calculator-img {
  max-width: 64px;
  max-height: 64px;
  object-fit: contain;
  margin-bottom: 6px;
}

.calculator-name {
  font-size: 13px;
  font-weight: 500;
}

.icones-bloco{
  color: #0056FF !important;
}

.botao-mover-bloco-azul {
  background-color: #0056FF;
  color: white;
  font-weight: bold;
  min-width: 2.2rem;
  padding: 0.25rem 0.5rem;
}

.cursor-pointer {
  cursor: pointer;
}

.form-check:hover {
  opacity: 0.85;
}


@media (max-width: 576px) {
  .blocos-grid .bloco {
    height: 150px;
  }

  .drag-icon{
    display: none;
  }

  .projeto-acao {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
  }

  .projeto-acao .btn {
    width: 100%;
  }
}

/* =========================
   BLOCO NO ESTILO "PROJETO"
   ========================= */

.bloco-card {
  border-radius: 12px;
  border: 1px solid #EDEFF2;
  background-color: #f8f9fa; /* mantém fundo padrão */
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
}

/* quando tem componente → mantém seu azul */
.bloco-card[draggable="true"] {
  background-color: #EDF7FF;
  cursor: grab;
}

.bloco-card[draggable="true"]:active {
  cursor: grabbing;
}

/* hover igual ao card de projeto */
.bloco-card:hover {
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  transform: none;
}

/* =========================
   DRAG & DROP (preservado)
   ========================= */

.bloco-card.arrastando {
  opacity: 0.55;
  border: 2px dashed #0056FF !important;
  background-color: #EAF2FF !important;
}

.col-12.col-md-4.sobreposto .bloco-card,
.col-12.col-md-3.sobreposto .bloco-card {
  border: 2px solid #0056FF !important;
  background-color: #DDEBFF !important;
}

/* =========================
   ÍCONES (DRAG + MENU)
   ========================= */

.icones-bloco {
  color: #0056FF !important;
}

/* drag handle */
.drag-icon {
  font-size: 16px !important;
  opacity: 0.5;
  padding: 9px 10px !important;
}

/* menu 3 pontinhos */
.tres-pontinhos {
  /* opacity: 0.8;
  transition: opacity 0.15s ease; */
}

.tres-pontinhos:hover {
  /* opacity: 1;
  color: #0056FF !important; */
}

#tres-pontinhos-componentes {
  font-size: 12px;
  color: #0056FF;
  background-color: white !important;
  padding: 6px 10px;
  border-radius: 8px;
}

/* =========================
   CONTEÚDO
   ========================= */

.titulo-componente {
  color: inherit;
  text-decoration: none;
}

.titulo-componente:hover {
  color: inherit;
  text-decoration: none;
}

/* =========================
   MOBILE
   ========================= */

@media (max-width: 576px) {
  .drag-icon {
    display: none;
  }

  .bloco-card {
    min-height: 150px;
  }

  .botao-mover-bloco-azul {
    background-color: #0056FF;
    color: white;
    font-weight: bold;
  }
}


</style>